/* eslint-disable max-len */
import {get, post, postJSON} from './http';

// 申请接入
// 获取审核状态
export const getUserApplyStatus = p => get('/api/v1/verification/status', p);
// 获取当前登陆用户信息
export const getInfo = (p, config) => get('/api/v1/user', p, config);

// export const getInfo = (p, config) => new Promise((resolve, reject) => {
//     resolve({
//         'res': 0,
//         'msg': 'ok',
//         'data': {
//             'accountName': 'test_auth',
//             'uuap': null,
//             'accountType': 'PASSPORT',
//             'userId': 10019,
//             'bceName': null,
//             'nickName': '',
//             'userType': 'customerManager',
//             'phone': '',
//             'email': '',
//             'companyName': '',
//             'supplyList': [
//                 {
//                     'supplyId': 7102,
//                     'type': 'Manager'
//                 },
//                 {
//                     'supplyId': 7103,
//                     'type': 'Customer'
//                 }
//             ]
//         }
//     });
// });
// 越过登录cookie获取登录信息
export const getSessionStatus = p => get('/api/v1/user/session/status', p);

// 提交审核
export const submitApply = p => post('/api/v1/verification', p);

// 数据监控
// 实时网络访问量
export const getTrafficTypeChartData = (p, config) => get('/api/v1/stat/pvTimeSharing', p, config);

// 实时网络访问量
export const getTrafficTypeChartTop10 = (p, config) => get('/api/v1/stat/pvTimeSharingReport', p, config);
// 近30天流量识别情况
export const getTrafficCodeChartData = p => get('/api/v1/stat/pvTrend', p);
// 未知爬虫IP
export const getTopBlackIP = p => get('/api/v1/stat/topBlackIp', p);
// 已知爬虫IP
export const getTopWhiteIP = p => get('/api/v1/stat/knownSpiderDetail', p);
// 已知爬虫分组
export const getKnownSpiderGroup = p => get('/api/v1/stat/knownSpiderGroup', p);

// 按爬虫来源显示昨日PV比例、IP比例
export const getDistribution = p => get('/api/v1/stat/cDistribution', p);

// 个人信息
// 修改个人信息
export const changeInfo = (p, config) => post('/api/v1/user/update', p, config);

// 查询IP/LID
// 查询访问记录数
export const getHistoryNum = p => get('/api/v1/history/recordCount', p);
// 查询lid或ip过去7天内的访问历史记录
export const getHistory = p => get('/api/v1/history', p);
// 获取ip某天访问记录的csv
export const downloadHistory = p => get('/api/v1/history/download', p);

// 权限管理
// 验证百度账号名
export const getAccountNameValidation = p => get('/api/v1/user/accountNameValidation', p);

export const getUuapValidation = p => get('/api/v1/user/uuapValidation', p);

// 新增用户
export const addUser = (p, config) => post('/api/v1/user/add', p, config);

// 获取用户列表
export const getUserList = p => get('/api/v1/user/list', p);

// 删除用户
export const deleteUser = p => get('/api/v1/user/delete', p);

// 获取supplyId对应的公司名列表
export const getSupplyId = p => get('/api/v1/supplyId', p);

// 获取对应supplyId的subid列表
export const getSubId = p => get('/api/v1/user/subid/list', p);

// 获取code对应的标签
export const getCodes = p => get('/api/v1/code', p);

// 获取marks数据
export const getMarks = p => get('/api/v1/mark', p);
// 更新策略
export const updateStrategy = (p, config) => postJSON('/api/v1/strategy/update', p, config);

// 获取历史版本
export const getStrategyHistoryList = p => get('/api/v1/strategy/history/list', p);
// 获取历史版本详情
export const getStrategyHistoryDetail = p => get('/api/v1/strategy/history/detail', p);

// 策略中心切换编辑组状态
export const toggleStrategyEdit = (p, config) => get('/api/v1/strategy/toggleStrategyEdit', p, config);

// 获取未知爬虫分组
export const getTopBlackIpGroup = p => get('/api/v1/stat/topBlackIpGroup', p);

// 获取设备指纹列表
export const getFgList = p => get('/api/v1/fg/list', p);
// 获取设备指纹ip列表
export const getFgIpList = p => get('/api/v1/fg/ip_list', p);
// 设备干预
export const fgSave = p => post('/api/v1/fg/save', p);
// 取消设备干预
export const fgDelete = p => post('/api/v1/fg/delete', p);
// 获取数据报表
export const getReportList = p => get('/api/v1/report/list', p);
// 导出数据报表
export const downloadDataReport = p => get('/api/v1/report/list/download', p);
// 百度干预开关切换
export const baiduInterveneTrigger = p => post('/api/v1/fg/baidu_interv/save', p);
// 权限信息
export const getAccessInfo = p => get('/api/v1/user/accessInfo', p);

// 日志报表实时流量
export const getLogReportRealFlow = p => get('/api/v1/log_report/push_monitor', p);
// 日志报表日志判定
export const getLogReportLogJudge = p => get('/api/v1/log_report/log_judge', p);
// 日志报表可疑流量
export const getLogReportSuspectStat = p => get('/api/v1/log_report/suspect_stat', p);

// 态势感知
export const getSituationAreaDist = p => get('/api/v1/awareness/city', p);
export const getSituation2027TopN = p => get('/api/v1/awareness/custom', p);
export const getSituationPredictionPv = p => get('/api/v1/awareness/predict', p);
export const getSituationRealPv = p => get('/api/v1/awareness/real', p);
export const getSituationFlowPrediction = p => get('/api/v1/awareness/predict', p);
export const getSituationIpTopN = p => get('/api/v1/awareness/city/ip', p);
export const getSituationCustomTopN = p => get('/api/v1/awareness/custom', p);

// 检测用户是否弃用
export const checkUserAbandon = p => get('/api/v1/user/enable');

export const getSingleLogTrafficChartData = (p, config) => get('/api/v1/log_stat/pvTimeSharing', p, config);
// export const getSingleLogTrafficChartData = (p, config) => {
//     return getTrafficTypeChartData(p, config).then(res => {
//         if (res.res === 0) {
//             const pc = res.data.pc;
//             delete res.data.mobile;
//             delete res.data.pc;
//             res.data.normal = pc;
//         }
//         return res;
//     });
// }

export const getCustomerLogTop10 = p => get('/api/v1/log_stat/pvTimeSharingReport', p);
// export const getCustomerLogTop10 = p => {
//     p.type = 4;
//     return getTrafficTypeChartTop10(p).then(res => {
//         res.data.forEach(item => {
//             item.name = item.ip;
//             item.value = item.pv;
//         });
//         return res;
//     });
// }

export const getCustomerLogHistory = p => get('/api/v1/log_stat/pvTrend', p);
// export const getCustomerLogHistory = p => {
//     return getLogReportLogJudge(p).then(res => {
//         res.data.unknownSpider = res.data.jsUnknownSpider;
//         return res;
//     });
// }

export const getCustimerFlowDistribute = p => get('/api/v1/log_stat/flowDistribution', p);
// export const getCustimerFlowDistribute = p => {
//     return new Promise((resolve) => {
//         const group = ['MAC_OS', 'MAC_OS_X', 'MAC_OS_X_IPAD', 'MAC_OS_X_IPHONE', 'MAC_OS_X_IPOD', 'MAEMO', 'MEEGO', 'None', 'PALM', 'PROXY', 'PSP', 'SERIES40'];
//         const res = [];
//         for (let i = 0; i < 200; i++) {
//             const value = parseInt(Math.random() * 20000);
//             const gi = Math.round(Math.random() * (group.length - 1));
//             const name = `${group[gi]}-${i}`;
//             res.push({value, name});
//         }
//         setTimeout(() => {
//             resolve({
//                 res: 0,
//                 msg: '',
//                 data: res
//             });
//         }, 1000);
//     });
// };

export const getCustomerTopList = p => get('/api/v1/log_stat/topList', p);
// export const getCustomerTopList = p => {
//     return new Promise((resolve) => {
//         const data = [];
//         const group = [
//             'ios', 'android', 'win', 'linux',
//             'plus-one', 'qinrs', 'kueta', 'castor'
//         ];
//         for (let i = 0; i < 100; i++) {
//             const value = parseInt(Math.random() * 20000);
//             const gi = Math.round(Math.random() * (group.length - 1));
//             const name = `${group[gi]}-${i}`;
//             data.push({value, name});
//         }
//         setTimeout(() => {
//             resolve({
//                 res: 0,
//                 msg: '',
//                 data: {
//                     dimensionTotalCount: 435,
//                     pvTotalCount: 12315,
//                     data
//                 }
//             });
//         }, 1000);
//     });
// };

export const getBasicIntelligence = p => get('/api/v1/threaten/basic', p);
// export const getBasicIntelligence = p => {
//     return new Promise(resolve => {
//         const id = p.id;
//         const {validateIp} = require('@/util/util');
//         const isIp = validateIp(id);
//         let data;
//         if (isIp) {
//             data = {
//                 res: 0,
//                 msg: '',
//                 data: {
//                     'type': 'ip',
//                     'ip': '12.23.4.2',
//                     'pv': 666,
//                     'rate': 0.6,
//                     'activity': '较高',
//                     'firstFound': '20201031',
//                     'lastFound': '20201104',
//                     'location': '广东 / 深圳',
//                     'idc': true,
//                     'isp': 'chinanet',
//                     'basestation': true
//                 }
//             };
//         } else {
//             data = {
//                 res: 0,
//                 msg: '',
//                 data: {
//                     type: 'uid',
//                     'uid': '23143158',
//                     'pv': 666,
//                     'rate': 0.6,
//                     'activity': '较高',
//                     'firstFound': '20201031',
//                     'lastFound': '20201104'
//                 }
//             };
//         }
//         setTimeout(() => {
//             resolve(data);
//         }, 1000);
//     });
// };

export const getThreatenPortrait = p => get('/api/v1/threaten/portrait', p);
// export const getThreatenPortrait = p => {
//     return new Promise(resolve => {
//         setTimeout(() => {
//             resolve({
//                 res: 0,
//                 msg: '',
//                 data: [{
//                     label: '代理',
//                     level: 1,
//                     type: '风控标签',
//                     description: '顶层风控标签'
//                 }, {
//                     label: '低点击率',
//                     level: 2,
//                     type: '行为标签',
//                     description: '描述与业务独立的ID行为'
//                 }, {
//                     label: '缸发动机攻防',
//                     level: 4,
//                     type: '业务标签',
//                     description: '描述与业务独立的ID行为'
//                 }, {
//                     label: '第三方代理',
//                     level: 4,
//                     type: '风控标签',
//                     description: '攻防的是固定顶层风控标签'
//                 }]
//             });
//         }, 2000);
//     });
// };

export const getThreatenHistory = p => get('/api/v1/threaten/historyjs', p);
// export const getThreatenHistory = p => {
//     return new Promise(resolve => {
//         const mockData = require('./mockTheatGroupData').mockHistoryData;
//         const data = mockData();
//         setTimeout(() => {
//             resolve({
//                 res: 0,
//                 msg: 'success',
//                 data: {
//                     totalCount: 521,
//                     data
//                 }
//             });
//         }, 10300);
//     });
// };

export const getThreatenCustHistory = p => get('/api/v1/threaten/historycust', p);
// export const getThreatenCustHistory = p => {
//     return new Promise(resolve => {
//         const mockData = require('./mockTheatGroupData').mockHistoryData;
//         const data = mockData();
//         setTimeout(() => {
//             resolve({
//                 res: 0,
//                 msg: 'success',
//                 data: {
//                     totalCount: 521,
//                     data
//                 }
//             });
//         }, 2400);
//     });
// };

export const getThreatenGroup = p => get('/api/v1/threaten/group', p);
// export const getThreatenGroup = p => {
//     return new Promise(resolve => {
//         const mockData = require('./mockTheatGroupData').default;
//         const data = mockData();
//         setTimeout(() => {
//             resolve({
//                 res: 0,
//                 msg: 'success',
//                 data
//             });
//         }, 1020);
//     });
// };

export const getRelationGroup = p => get('/api/v1/threaten/relation', p);
// export const getRelationGroup = p => {
//     return new Promise(resolve => {
//         const mockData = require('./mockTheatGroupData').default;
//         const data = mockData();
//         setTimeout(() => {
//             resolve({
//                 res: 0,
//                 msg: 'success',
//                 data
//             });
//         }, 1020);
//     });
// };

export const getSupplyHistory = p => get('/api/v1/threaten/relation/history', p);
// export const getSupplyHistory = p => {
//     return new Promise(resolve => {
//         setTimeout(() => {
//             const dayjs = require('dayjs');
//             const supplyIds = [
//                 2023, 2024, 2022, 2025, 2026, 2027, 2028, 2029,
//                 2030, 2031, 2032, 2033, 2034, 2035, 2036, 2037
//             ];
//             const data = {};
//             for (let i = 0; i < 7; i++) {
//                 let date = dayjs().subtract(i, 'day').format('YYYYMMDD');
//                 const dateData = {};
//                 supplyIds.forEach(sid => {
//                     dateData[sid] = parseInt(Math.random() * 100000);
//                 });
//                 data[date] = dateData;
//             }
//             resolve({
//                 res: 0,
//                 msg: 'success',
//                 data
//             });
//         }, 1000);
//     });
// }

export const getDomainList = p => get('/api/v1/domain/list', p);
export const getYJSDomainList = p => get('/api/v1/domain/listV2', p);
// export const getYJSDomainList = p =>
//     new Promise(resolve => {
//         setTimeout(() => {
//             resolve({
//                 res: 0,
//                 msg: 'success',
//                 data: [
//                     {
//                         id: 1,
//                         host_name: 'test.com',
//                         created_on: '2022-06-16T11:12:54+08:00',
//                         is_synced: true
//                     },
//                     {
//                         id: 2,
//                         host_name: '1test.com',
//                         created_on: '2022-06-16T11:12:54+08:00',
//                         is_synced: false
//                     }
//                 ]
//             });
//         }, 1000);
//     });
// export const getDomainList = p => {
//     return new Promise(resolve => {
//         setTimeout(() => {
//             resolve({
//                 res: 0,
//                 msg: 'success',
//                 data: [{
//                     id: 1,
//                     name: 'test.com'
//                 }, {
//                     id: 2,
//                     name: '1test.com'
//                 }]
//             });
//         }, 1000);
//     });
// }

export const getSubdomainList = p => get('/api/v1/subdomain/list', p);
// export const getSubdomainList = p => {
//     return new Promise(resolve => {
//         setTimeout(() => {
//             resolve({
//                 res: 0,
//                 msg: 'success',
//                 data: [{
//                     "id": 10006,
//                     "name": "www.test.com",
//                     "zone": 1,
//                     "zone_name": "test.com",
//                     "type": "cname",
//                     "require_cname": "",
//                     "dns_group": "",
//                     "plan": "free",
//                     "suffix": "",
//                     "status": "active"
//                 }, {
//                     "id": 10007,
//                     "name": "a1.test.com",
//                     "zone": 1,
//                     "zone_name": "test.com",
//                     "type": "cname",
//                     "require_cname": "",
//                     "dns_group": "",
//                     "plan": "free",
//                     "suffix": "",
//                     "status": "pending"
//                 }, {
//                     "id": 10008,
//                     "name": "a2.test.com",
//                     "zone": 1,
//                     "zone_name": "test.com",
//                     "type": "cname",
//                     "require_cname": "",
//                     "dns_group": "",
//                     "plan": "free",
//                     "suffix": "",
//                     "status": "pending"
//                 }]
//             });
//         }, 1000);
//     });
// }

export const addDomain = p => post('/api/v1/domain/add', p);
// export const addDomain = p => new Promise(resolve => {
//     setTimeout(() => {
//         const id = Math.random();
//         resolve({
//             res: 0,
//             msg: '',
//             data: {
//                 id,
//                 name: p.domain
//             }
//         })
//     }, 1000);
// });

export const addSubdomain = p => post('/api/v1/subdomain/add', p);
// export const addSubdomain = p => new Promise(resolve => {
//     setTimeout(() => {
//         const id = Math.random();
//         resolve({
//             res: 0,
//             msg: '',
//             data: {
//                 id,
//                 name: p.subdomain,
//                 zone_id: p.domainId
//             }
//         })
//     }, 1000);
// });

export const deleteDomain = p => post('/api/v1/domain/delete', p);
// export const deleteDomain = p => new Promise(resolve => {
//     setTimeout(() => {
//         resolve({
//             res: 0,
//             msg: 'das-d',
//             data: null
//         })
//     }, 1000);
// });

export const deleteSubdomain = p => post('/api/v1/subdomain/delete', p);
// export const deleteSubdomain = p => new Promise(resolve => {
//     setTimeout(() => {
//         resolve({
//             res: 0,
//             msg: 'dsdsd',
//             data: null
//         })
//     }, 1000);
// });

export const getJssdkInfo = p => get('/api/v1/docs/jssdkInfo', p);
// export const getJssdkInfo = p => new Promise(resolve => {
//     setTimeout(() => {
//         resolve({
//             res: 0,
//             msg: '',
//             data: {
//                 cdnFilename: 'abclite-7102-s.js',
//                 supplyId: 7102
//             }
//         })
//     }, 1000);
// });

export const getSecretInfo = p => get('/api/v1/user/info/secretInfo', p);

// export const getSecretInfo = p => new Promise(resolve => {
//     setTimeout(() => {
//         resolve({
//             res: 0,
//             msg: '',
//             data: {
//                 token: {
//                     key: 'sdkjasjdkasjdksa'
//                 },
//                 secret: {
//                     ak: 'asdasdshjfdshjfds',
//                     sk: 'sdsadsadasddsjkfk'
//                 }
//             }
//         })
//     }, 1000);
// })
export const getApiMonitorQps = p => get('/api/v1/api_stat/qps', p);
// export const getApiMonitorQps = p =>
//     new Promise(resolve => {
//         const {start, end, step} = p;
//         const keys = ['QPS'];
//         let preValue = 20000;
//         const modeData = {
//             res: 0,
//             data: {
//                 resultType: 'matrix',
//                 result: keys.map(key => {
//                     const result = {};
//                     result.metric = {};
//                     const values = [];
//                     for (let t = start; t < end; t = t + step * 1000 * 60) {
//                         const scale = Math.random() > 0.5 ? 0.05 : -0.05;
//                         const v = [t, preValue * scale + preValue + ''];
//                         preValue = parseFloat(v[1]);
//                         values.push(v);
//                     }
//                     result.values = values;
//                     return result;
//                 })
//             }
//         };

//         setTimeout(() => {
//             resolve(modeData);
//         }, 1000);
//     });

export const getApiMonitorHitRule = p => get('/api/v1/api_stat/comb', p);
// export const getApiMonitorHitRule = p =>
//     new Promise(resolve => {
//         const {start, end, step} = p;
//         const keys = ['BAIDUID Frequency Over Threshold', 'threat_ja3_ip', 'afghjklbnm'];
//         const modeData = {
//             res: 0,
//             data: {
//                 resultType: 'matrix',
//                 result: keys.map(key => {
//                     const result = {};
//                     result.metric = {name: key};
//                     const values = [];
//                     let preValue = 2000;
//                     for (let t = start; t < end; t = t + step * 1000 * 60) {
//                         const scale = Math.random() > 0.5 ? 0.05 : -0.05;
//                         const v = [t, preValue * scale + preValue + ''];
//                         preValue = parseFloat(v[1]);
//                         values.push(v);
//                     }
//                     result.values = values;
//                     return result;
//                 })
//             }
//         };

//         setTimeout(() => {
//             resolve(modeData);
//         }, 1000);
//     });

export const getResponseTimeAvg = p => get('/api/v1/api_stat/response_time_avg', p);

// export const getResponseTimeAvg = p =>
//     new Promise(resolve => {
//         const {start, end, step} = p;
//         const keys = ['response_time_avg'];
//         let preValue = 20000;
//         const modeData = {
//             res: 0,
//             data: {
//                 resultType: 'matrix',
//                 result: keys.map(key => {
//                     const result = {};
//                     result.metric = {};
//                     const values = [];
//                     for (let t = start; t < end; t = t + step * 1000 * 60) {
//                         const scale = Math.random() > 0.5 ? 0.05 : -0.05;
//                         const v = [t, preValue * scale + preValue + ''];
//                         preValue = parseFloat(v[1]);
//                         values.push(v);
//                     }
//                     result.values = values;
//                     return result;
//                 })
//             }
//         };

//         setTimeout(() => {
//             resolve(modeData);
//         }, 1000);
//     });

export const getApiRiskLevel = p => get('/api/v1/api_stat/risk', p);
// export const getApiRiskLevel = p =>
//     new Promise(resolve => {
//         const {start, end, step} = p;
//         const keys = ['high', 'none'];
//         const modeData = {
//             res: 0,
//             data: {
//                 resultType: 'matrix',
//                 result: keys.map(key => {
//                     const result = {};
//                     result.metric = {name: key};
//                     const values = [];
//                     let preValue = 2000;
//                     for (let t = start; t < end; t = t + step * 1000 * 60) {
//                         const scale = Math.random() > 0.5 ? 0.05 : -0.05;
//                         const v = [t, preValue * scale + preValue + ''];
//                         preValue = parseFloat(v[1]);
//                         values.push(v);
//                     }
//                     result.values = values;
//                     return result;
//                 })
//             }
//         };

//         setTimeout(() => {
//             resolve(modeData);
//         }, 1000);
//     });


export const getBusinessAnalysisInterfaceOverview = p => get('/api/v1/analysisReport/summary', p);
// export const getBusinessAnalysisInterfaceOverview = p => {
//     console.log('getBusinessAnalysisInterfaceOverview');
//     return new Promise(resolve => {
//         resolve({
//             res: 0,
//             data: [
//                 {
//                     uriPath: '/nchat/api/getorderlist',
//                     pv: 10619852,
//                     spiderPv: 3490819
//                 },
//                 {
//                     uriPath: '/nchat/submit/cananswer',
//                     pv: 510374,
//                     spiderPv: 150216
//                 }
//             ]
//         });
//     });
// };

export const getBusinessAnalyseCustDr1RealFlow = p => get('/api/v1/analysisReport/pvTrend', p);
// export const getBusinessAnalyseCustDr1RealFlow = p => {
//     console.log('getBusinessAnalyseCustDr1RealFlow');
//     const data = {
//         res: 0,
//         msg: 'ok',
//         data: {
//             logCnt: [
//                 {time: '202302211650', val: '1610879'},
//                 {time: '202302211655', val: '1549612'},
//                 {time: '202302211700', val: '1501102'},
//                 {time: '202302211705', val: '1526512'},
//                 {time: '202302211710', val: '1562540'},
//                 {time: '202302211715', val: '1559307'},
//                 {time: '202302211720', val: '1569013'},
//                 {time: '202302211725', val: '1463610'},
//                 {time: '202302211730', val: '1482141'},
//                 {time: '202302211735', val: '1408362'},
//                 {time: '202302211740', val: '1395963'},
//                 {time: '202302211745', val: '1396080'},
//                 {time: '202302211750', val: '1411951'},
//                 {time: '202302211755', val: '1401866'},
//                 {time: '202302211800', val: '1350793'},
//                 {time: '202302211805', val: '1335215'},
//                 {time: '202302211810', val: '1365595'},
//                 {time: '202302211815', val: '1291524'},
//                 {time: '202302211820', val: '1334987'},
//                 {time: '202302211825', val: '1336177'},
//                 {time: '202302211830', val: '1298853'},
//                 {time: '202302211835', val: '1288201'},
//                 {time: '202302211840', val: '1299028'},
//                 {time: '202302211845', val: '1294781'},
//                 {time: '202302211850', val: '1348156'},
//                 {time: '202302211855', val: '1363538'},
//                 {time: '202302211900', val: '1333390'},
//                 {time: '202302211905', val: '1362882'},
//                 {time: '202302211910', val: '1418498'},
//                 {time: '202302211915', val: '1444621'},
//                 {time: '202302211920', val: '1473012'},
//                 {time: '202302211925', val: '1381016'},
//                 {time: '202302211930', val: '1436668'},
//                 {time: '202302211935', val: '1422087'},
//                 {time: '202302211940', val: '1444622'},
//                 {time: '202302211945', val: '1459614'},
//                 {time: '202302211950', val: '1470741'},
//                 {time: '202302211955', val: '1438839'},
//                 {time: '202302212000', val: '1464635'},
//                 {time: '202302212005', val: '1488564'},
//                 {time: '202302212010', val: '1502230'},
//                 {time: '202302212015', val: '1522051'},
//                 {time: '202302212020', val: '1493683'},
//                 {time: '202302212025', val: '1536255'},
//                 {time: '202302212030', val: '1510626'},
//                 {time: '202302212035', val: '1486743'},
//                 {time: '202302212040', val: '1477139'},
//                 {time: '202302212045', val: '1487724'},
//                 {time: '202302212050', val: '1540031'},
//                 {time: '202302212055', val: '1577886'},
//                 {time: '202302212100', val: '1460892'},
//                 {time: '202302212105', val: '1480746'},
//                 {time: '202302212110', val: '1423821'},
//                 {time: '202302212115', val: '1510034'},
//                 {time: '202302212120', val: '1478929'},
//                 {time: '202302212125', val: '1436826'},
//                 {time: '202302212130', val: '1418372'},
//                 {time: '202302212135', val: '1508301'},
//                 {time: '202302212140', val: '1499580'},
//                 {time: '202302212145', val: '1499248'},
//                 {time: '202302212150', val: '1507378'},
//                 {time: '202302212155', val: '1523830'},
//                 {time: '202302212200', val: '1520882'},
//                 {time: '202302212205', val: '1535444'},
//                 {time: '202302212210', val: '1537340'},
//                 {time: '202302212215', val: '1537214'},
//                 {time: '202302212220', val: '1493265'},
//                 {time: '202302212225', val: '1464806'},
//                 {time: '202302212230', val: '1431120'},
//                 {time: '202302212235', val: '1495792'},
//                 {time: '202302212240', val: '1410325'},
//                 {time: '202302212245', val: '1490918'},
//                 {time: '202302212250', val: '1400006'},
//                 {time: '202302212255', val: '1545726'},
//                 {time: '202302212300', val: '1361746'},
//                 {time: '202302212305', val: '1339360'},
//                 {time: '202302212310', val: '1295024'},
//                 {time: '202302212315', val: '1233409'},
//                 {time: '202302212320', val: '1284222'},
//                 {time: '202302212325', val: '1285206'},
//                 {time: '202302212330', val: '1252594'},
//                 {time: '202302212335', val: '1242143'},
//                 {time: '202302212340', val: '1252576'},
//                 {time: '202302212345', val: '1207510'},
//                 {time: '202302212350', val: '1175187'},
//                 {time: '202302212355', val: '1177254'},
//                 {time: '202302220000', val: '1202665'},
//                 {time: '202302220005', val: '1155657'},
//                 {time: '202302220010', val: '1116913'},
//                 {time: '202302220015', val: '1168394'},
//                 {time: '202302220020', val: '1108797'},
//                 {time: '202302220025', val: '1072138'},
//                 {time: '202302220030', val: '1045391'},
//                 {time: '202302220035', val: '1053824'},
//                 {time: '202302220040', val: '1031952'},
//                 {time: '202302220045', val: '1017534'},
//                 {time: '202302220050', val: '1060865'},
//                 {time: '202302220055', val: '1181489'},
//                 {time: '202302220100', val: '1025152'},
//                 {time: '202302220105', val: '952927'},
//                 {time: '202302220110', val: '846354'},
//                 {time: '202302220115', val: '873856'},
//                 {time: '202302220120', val: '907890'},
//                 {time: '202302220125', val: '913746'},
//                 {time: '202302220130', val: '894191'},
//                 {time: '202302220135', val: '837723'},
//                 {time: '202302220140', val: '915018'},
//                 {time: '202302220145', val: '909993'},
//                 {time: '202302220150', val: '755622'},
//                 {time: '202302220155', val: '906628'},
//                 {time: '202302220200', val: '910349'},
//                 {time: '202302220205', val: '793713'},
//                 {time: '202302220210', val: '837089'},
//                 {time: '202302220215', val: '867130'},
//                 {time: '202302220220', val: '838589'},
//                 {time: '202302220225', val: '846549'},
//                 {time: '202302220230', val: '754151'},
//                 {time: '202302220235', val: '723348'},
//                 {time: '202302220240', val: '754234'},
//                 {time: '202302220245', val: '785395'},
//                 {time: '202302220250', val: '711215'},
//                 {time: '202302220255', val: '881360'},
//                 {time: '202302220300', val: '762092'},
//                 {time: '202302220305', val: '692725'},
//                 {time: '202302220310', val: '772712'},
//                 {time: '202302220315', val: '750020'},
//                 {time: '202302220320', val: '701502'},
//                 {time: '202302220325', val: '574884'},
//                 {time: '202302220330', val: '673165'},
//                 {time: '202302220335', val: '752441'},
//                 {time: '202302220340', val: '733574'},
//                 {time: '202302220345', val: '668672'},
//                 {time: '202302220350', val: '720457'},
//                 {time: '202302220355', val: '710888'},
//                 {time: '202302220400', val: '636611'},
//                 {time: '202302220405', val: '633416'},
//                 {time: '202302220410', val: '664148'},
//                 {time: '202302220415', val: '635163'},
//                 {time: '202302220420', val: '695313'},
//                 {time: '202302220425', val: '621005'},
//                 {time: '202302220430', val: '662634'},
//                 {time: '202302220435', val: '663675'},
//                 {time: '202302220440', val: '686517'},
//                 {time: '202302220445', val: '648357'},
//                 {time: '202302220450', val: '771617'},
//                 {time: '202302220455', val: '632333'},
//                 {time: '202302220500', val: '667191'},
//                 {time: '202302220505', val: '666451'},
//                 {time: '202302220510', val: '633000'},
//                 {time: '202302220515', val: '702151'},
//                 {time: '202302220520', val: '619579'},
//                 {time: '202302220525', val: '678848'},
//                 {time: '202302220530', val: '704931'},
//                 {time: '202302220535', val: '732575'},
//                 {time: '202302220540', val: '657689'},
//                 {time: '202302220545', val: '683467'},
//                 {time: '202302220550', val: '682837'},
//                 {time: '202302220555', val: '668027'},
//                 {time: '202302220600', val: '703327'},
//                 {time: '202302220605', val: '692481'},
//                 {time: '202302220610', val: '626592'},
//                 {time: '202302220615', val: '717625'},
//                 {time: '202302220620', val: '756563'},
//                 {time: '202302220625', val: '731684'},
//                 {time: '202302220630', val: '728569'},
//                 {time: '202302220635', val: '733324'},
//                 {time: '202302220640', val: '696948'},
//                 {time: '202302220645', val: '755036'},
//                 {time: '202302220650', val: '673984'},
//                 {time: '202302220655', val: '709015'},
//                 {time: '202302220700', val: '664309'},
//                 {time: '202302220705', val: '745130'},
//                 {time: '202302220710', val: '770372'},
//                 {time: '202302220715', val: '777510'},
//                 {time: '202302220720', val: '729918'},
//                 {time: '202302220725', val: '697639'},
//                 {time: '202302220730', val: '710004'},
//                 {time: '202302220735', val: '778367'},
//                 {time: '202302220740', val: '742983'},
//                 {time: '202302220745', val: '841093'},
//                 {time: '202302220750', val: '812789'},
//                 {time: '202302220755', val: '797572'},
//                 {time: '202302220800', val: '802253'},
//                 {time: '202302220805', val: '890797'},
//                 {time: '202302220810', val: '882432'},
//                 {time: '202302220815', val: '973407'},
//                 {time: '202302220820', val: '1057172'},
//                 {time: '202302220825', val: '1025958'},
//                 {time: '202302220830', val: '1021502'},
//                 {time: '202302220835', val: '1066653'},
//                 {time: '202302220840', val: '1078584'},
//                 {time: '202302220845', val: '1200214'},
//                 {time: '202302220850', val: '1212903'},
//                 {time: '202302220855', val: '1251184'},
//                 {time: '202302220900', val: '1167772'},
//                 {time: '202302220905', val: '1241726'},
//                 {time: '202302220910', val: '1241708'},
//                 {time: '202302220915', val: '1289285'},
//                 {time: '202302220920', val: '1377793'},
//                 {time: '202302220925', val: '1410794'},
//                 {time: '202302220930', val: '1377747'},
//                 {time: '202302220935', val: '1354355'},
//                 {time: '202302220940', val: '1469374'},
//                 {time: '202302220945', val: '1422383'},
//                 {time: '202302220950', val: '1448953'},
//                 {time: '202302220955', val: '1374461'},
//                 {time: '202302221000', val: '1452960'},
//                 {time: '202302221005', val: '1485728'},
//                 {time: '202302221010', val: '1487540'},
//                 {time: '202302221015', val: '1432183'},
//                 {time: '202302221020', val: '1482330'},
//                 {time: '202302221025', val: '1566513'},
//                 {time: '202302221030', val: '1479308'},
//                 {time: '202302221035', val: '1546891'},
//                 {time: '202302221040', val: '1592657'},
//                 {time: '202302221045', val: '1610418'},
//                 {time: '202302221050', val: '1571661'},
//                 {time: '202302221055', val: '1576837'},
//                 {time: '202302221100', val: '1622947'},
//                 {time: '202302221105', val: '1584144'},
//                 {time: '202302221110', val: '1520464'},
//                 {time: '202302221115', val: '1529738'},
//                 {time: '202302221120', val: '1558527'},
//                 {time: '202302221125', val: '1549118'},
//                 {time: '202302221130', val: '1528109'},
//                 {time: '202302221135', val: '1448114'},
//                 {time: '202302221140', val: '1472759'},
//                 {time: '202302221145', val: '1435022'},
//                 {time: '202302221150', val: '1430795'},
//                 {time: '202302221155', val: '1404410'},
//                 {time: '202302221200', val: '1337171'},
//                 {time: '202302221205', val: '1223408'},
//                 {time: '202302221210', val: '1175770'},
//                 {time: '202302221215', val: '1287340'},
//                 {time: '202302221220', val: '1214831'},
//                 {time: '202302221225', val: '1384287'},
//                 {time: '202302221230', val: '1253161'},
//                 {time: '202302221235', val: '1324625'},
//                 {time: '202302221240', val: '1287989'},
//                 {time: '202302221245', val: '1322874'},
//                 {time: '202302221250', val: '1350578'},
//                 {time: '202302221255', val: '1313976'},
//                 {time: '202302221300', val: '1323095'},
//                 {time: '202302221305', val: '1332963'},
//                 {time: '202302221310', val: '1330833'},
//                 {time: '202302221315', val: '1303479'},
//                 {time: '202302221320', val: '1288806'},
//                 {time: '202302221325', val: '1321209'},
//                 {time: '202302221330', val: '1354251'},
//                 {time: '202302221335', val: '1378516'},
//                 {time: '202302221340', val: '1404791'},
//                 {time: '202302221345', val: '1420148'},
//                 {time: '202302221350', val: '1425580'},
//                 {time: '202302221355', val: '1483049'},
//                 {time: '202302221400', val: '1412317'},
//                 {time: '202302221405', val: '1414828'},
//                 {time: '202302221410', val: '1465453'},
//                 {time: '202302221415', val: '1495339'},
//                 {time: '202302221420', val: '1537331'},
//                 {time: '202302221425', val: '1623034'},
//                 {time: '202302221430', val: '1556999'},
//                 {time: '202302221435', val: '1513815'},
//                 {time: '202302221440', val: '1520030'},
//                 {time: '202302221445', val: '1537865'},
//                 {time: '202302221450', val: '1632283'},
//                 {time: '202302221455', val: '1632133'},
//                 {time: '202302221500', val: '1555100'},
//                 {time: '202302221505', val: '1619236'},
//                 {time: '202302221510', val: '1637289'},
//                 {time: '202302221515', val: '1610948'},
//                 {time: '202302221520', val: '1577722'},
//                 {time: '202302221525', val: '1643031'},
//                 {time: '202302221530', val: '1576602'},
//                 {time: '202302221535', val: '1622419'},
//                 {time: '202302221540', val: '1611856'},
//                 {time: '202302221545', val: '1602654'},
//                 {time: '202302221550', val: '1621871'},
//                 {time: '202302221555', val: '1618619'},
//                 {time: '202302221600', val: '1609136'},
//                 {time: '202302221605', val: '1622221'},
//                 {time: '202302221610', val: '1619499'},
//                 {time: '202302221615', val: '1613737'},
//                 {time: '202302221620', val: '1634541'},
//                 {time: '202302221625', val: '1731325'},
//                 {time: '202302221630', val: '1617261'},
//                 {time: '202302221635', val: '1527497'},
//                 {time: '202302221640', val: '1590103'},
//                 {time: '202302221645', val: '1617472'},
//                 {time: '202302221650', val: '1621962'}
//             ],
//             blackLogCnt: [
//                 {time: '202302211650', val: '343076'},
//                 {time: '202302211655', val: '340766'},
//                 {time: '202302211700', val: '317045'},
//                 {time: '202302211705', val: '319633'},
//                 {time: '202302211710', val: '320054'},
//                 {time: '202302211715', val: '318299'},
//                 {time: '202302211720', val: '343798'},
//                 {time: '202302211725', val: '318171'},
//                 {time: '202302211730', val: '317124'},
//                 {time: '202302211735', val: '312854'},
//                 {time: '202302211740', val: '301184'},
//                 {time: '202302211745', val: '305107'},
//                 {time: '202302211750', val: '308611'},
//                 {time: '202302211755', val: '305193'},
//                 {time: '202302211800', val: '305182'},
//                 {time: '202302211805', val: '319108'},
//                 {time: '202302211810', val: '322895'},
//                 {time: '202302211815', val: '325914'},
//                 {time: '202302211820', val: '330512'},
//                 {time: '202302211825', val: '320447'},
//                 {time: '202302211830', val: '319299'},
//                 {time: '202302211835', val: '307525'},
//                 {time: '202302211840', val: '310850'},
//                 {time: '202302211845', val: '307822'},
//                 {time: '202302211850', val: '317303'},
//                 {time: '202302211855', val: '324794'},
//                 {time: '202302211900', val: '330386'},
//                 {time: '202302211905', val: '326084'},
//                 {time: '202302211910', val: '345181'},
//                 {time: '202302211915', val: '342693'},
//                 {time: '202302211920', val: '366777'},
//                 {time: '202302211925', val: '354043'},
//                 {time: '202302211930', val: '359150'},
//                 {time: '202302211935', val: '360460'},
//                 {time: '202302211940', val: '367220'},
//                 {time: '202302211945', val: '367947'},
//                 {time: '202302211950', val: '378558'},
//                 {time: '202302211955', val: '360488'},
//                 {time: '202302212000', val: '363639'},
//                 {time: '202302212005', val: '378380'},
//                 {time: '202302212010', val: '378878'},
//                 {time: '202302212015', val: '385601'},
//                 {time: '202302212020', val: '395351'},
//                 {time: '202302212025', val: '392157'},
//                 {time: '202302212030', val: '385238'},
//                 {time: '202302212035', val: '373238'},
//                 {time: '202302212040', val: '370487'},
//                 {time: '202302212045', val: '363555'},
//                 {time: '202302212050', val: '363029'},
//                 {time: '202302212055', val: '373211'},
//                 {time: '202302212100', val: '362047'},
//                 {time: '202302212105', val: '356848'},
//                 {time: '202302212110', val: '360011'},
//                 {time: '202302212115', val: '378797'},
//                 {time: '202302212120', val: '390595'},
//                 {time: '202302212125', val: '435363'},
//                 {time: '202302212130', val: '418190'},
//                 {time: '202302212135', val: '436727'},
//                 {time: '202302212140', val: '446375'},
//                 {time: '202302212145', val: '447907'},
//                 {time: '202302212150', val: '559787'},
//                 {time: '202302212155', val: '668599'},
//                 {time: '202302212200', val: '663686'},
//                 {time: '202302212205', val: '664724'},
//                 {time: '202302212210', val: '656452'},
//                 {time: '202302212215', val: '666390'},
//                 {time: '202302212220', val: '661045'},
//                 {time: '202302212225', val: '657622'},
//                 {time: '202302212230', val: '638678'},
//                 {time: '202302212235', val: '650592'},
//                 {time: '202302212240', val: '627660'},
//                 {time: '202302212245', val: '642466'},
//                 {time: '202302212250', val: '618651'},
//                 {time: '202302212255', val: '681303'},
//                 {time: '202302212300', val: '611003'},
//                 {time: '202302212305', val: '570140'},
//                 {time: '202302212310', val: '557381'},
//                 {time: '202302212315', val: '535508'},
//                 {time: '202302212320', val: '540558'},
//                 {time: '202302212325', val: '542623'},
//                 {time: '202302212330', val: '528545'},
//                 {time: '202302212335', val: '515892'},
//                 {time: '202302212340', val: '523094'},
//                 {time: '202302212345', val: '511381'},
//                 {time: '202302212350', val: '502404'},
//                 {time: '202302212355', val: '509317'},
//                 {time: '202302220000', val: '507070'},
//                 {time: '202302220005', val: '464621'},
//                 {time: '202302220010', val: '449611'},
//                 {time: '202302220015', val: '481678'},
//                 {time: '202302220020', val: '479467'},
//                 {time: '202302220025', val: '433627'},
//                 {time: '202302220030', val: '430548'},
//                 {time: '202302220035', val: '452913'},
//                 {time: '202302220040', val: '446949'},
//                 {time: '202302220045', val: '429415'},
//                 {time: '202302220050', val: '450283'},
//                 {time: '202302220055', val: '499582'},
//                 {time: '202302220100', val: '432139'},
//                 {time: '202302220105', val: '389695'},
//                 {time: '202302220110', val: '362207'},
//                 {time: '202302220115', val: '354509'},
//                 {time: '202302220120', val: '371312'},
//                 {time: '202302220125', val: '371920'},
//                 {time: '202302220130', val: '362680'},
//                 {time: '202302220135', val: '338726'},
//                 {time: '202302220140', val: '347639'},
//                 {time: '202302220145', val: '357748'},
//                 {time: '202302220150', val: '312930'},
//                 {time: '202302220155', val: '354630'},
//                 {time: '202302220200', val: '352775'},
//                 {time: '202302220205', val: '311656'},
//                 {time: '202302220210', val: '306632'},
//                 {time: '202302220215', val: '340776'},
//                 {time: '202302220220', val: '336304'},
//                 {time: '202302220225', val: '341699'},
//                 {time: '202302220230', val: '301976'},
//                 {time: '202302220235', val: '272343'},
//                 {time: '202302220240', val: '268108'},
//                 {time: '202302220245', val: '280524'},
//                 {time: '202302220250', val: '268156'},
//                 {time: '202302220255', val: '347555'},
//                 {time: '202302220300', val: '282534'},
//                 {time: '202302220305', val: '253150'},
//                 {time: '202302220310', val: '275846'},
//                 {time: '202302220315', val: '263879'},
//                 {time: '202302220320', val: '262246'},
//                 {time: '202302220325', val: '231543'},
//                 {time: '202302220330', val: '248454'},
//                 {time: '202302220335', val: '274118'},
//                 {time: '202302220340', val: '267959'},
//                 {time: '202302220345', val: '249685'},
//                 {time: '202302220350', val: '252180'},
//                 {time: '202302220355', val: '259008'},
//                 {time: '202302220400', val: '232230'},
//                 {time: '202302220405', val: '213764'},
//                 {time: '202302220410', val: '219050'},
//                 {time: '202302220415', val: '218286'},
//                 {time: '202302220420', val: '240339'},
//                 {time: '202302220425', val: '210451'},
//                 {time: '202302220430', val: '221982'},
//                 {time: '202302220435', val: '234038'},
//                 {time: '202302220440', val: '241253'},
//                 {time: '202302220445', val: '233055'},
//                 {time: '202302220450', val: '266611'},
//                 {time: '202302220455', val: '235603'},
//                 {time: '202302220500', val: '231204'},
//                 {time: '202302220505', val: '228834'},
//                 {time: '202302220510', val: '214508'},
//                 {time: '202302220515', val: '237694'},
//                 {time: '202302220520', val: '217186'},
//                 {time: '202302220525', val: '233711'},
//                 {time: '202302220530', val: '247849'},
//                 {time: '202302220535', val: '266799'},
//                 {time: '202302220540', val: '239226'},
//                 {time: '202302220545', val: '241044'},
//                 {time: '202302220550', val: '238774'},
//                 {time: '202302220555', val: '243393'},
//                 {time: '202302220600', val: '245201'},
//                 {time: '202302220605', val: '250330'},
//                 {time: '202302220610', val: '236899'},
//                 {time: '202302220615', val: '265079'},
//                 {time: '202302220620', val: '266385'},
//                 {time: '202302220625', val: '289456'},
//                 {time: '202302220630', val: '275190'},
//                 {time: '202302220635', val: '265109'},
//                 {time: '202302220640', val: '260305'},
//                 {time: '202302220645', val: '284923'},
//                 {time: '202302220650', val: '277102'},
//                 {time: '202302220655', val: '283564'},
//                 {time: '202302220700', val: '270611'},
//                 {time: '202302220705', val: '285007'},
//                 {time: '202302220710', val: '297477'},
//                 {time: '202302220715', val: '306949'},
//                 {time: '202302220720', val: '286135'},
//                 {time: '202302220725', val: '280667'},
//                 {time: '202302220730', val: '285994'},
//                 {time: '202302220735', val: '308418'},
//                 {time: '202302220740', val: '312636'},
//                 {time: '202302220745', val: '324719'},
//                 {time: '202302220750', val: '327190'},
//                 {time: '202302220755', val: '316265'},
//                 {time: '202302220800', val: '324528'},
//                 {time: '202302220805', val: '341321'},
//                 {time: '202302220810', val: '352176'},
//                 {time: '202302220815', val: '380458'},
//                 {time: '202302220820', val: '411816'},
//                 {time: '202302220825', val: '420584'},
//                 {time: '202302220830', val: '417755'},
//                 {time: '202302220835', val: '439042'},
//                 {time: '202302220840', val: '451248'},
//                 {time: '202302220845', val: '478792'},
//                 {time: '202302220850', val: '492602'},
//                 {time: '202302220855', val: '513717'},
//                 {time: '202302220900', val: '480845'},
//                 {time: '202302220905', val: '489863'},
//                 {time: '202302220910', val: '507220'},
//                 {time: '202302220915', val: '518240'},
//                 {time: '202302220920', val: '538230'},
//                 {time: '202302220925', val: '559664'},
//                 {time: '202302220930', val: '565778'},
//                 {time: '202302220935', val: '548678'},
//                 {time: '202302220940', val: '574205'},
//                 {time: '202302220945', val: '565722'},
//                 {time: '202302220950', val: '574134'},
//                 {time: '202302220955', val: '551705'},
//                 {time: '202302221000', val: '592355'},
//                 {time: '202302221005', val: '587784'},
//                 {time: '202302221010', val: '608590'},
//                 {time: '202302221015', val: '598597'},
//                 {time: '202302221020', val: '593537'},
//                 {time: '202302221025', val: '625235'},
//                 {time: '202302221030', val: '608358'},
//                 {time: '202302221035', val: '628036'},
//                 {time: '202302221040', val: '644674'},
//                 {time: '202302221045', val: '648939'},
//                 {time: '202302221050', val: '641490'},
//                 {time: '202302221055', val: '648776'},
//                 {time: '202302221100', val: '653817'},
//                 {time: '202302221105', val: '632051'},
//                 {time: '202302221110', val: '618553'},
//                 {time: '202302221115', val: '628595'},
//                 {time: '202302221120', val: '624658'},
//                 {time: '202302221125', val: '632454'},
//                 {time: '202302221130', val: '621197'},
//                 {time: '202302221135', val: '611349'},
//                 {time: '202302221140', val: '599418'},
//                 {time: '202302221145', val: '599919'},
//                 {time: '202302221150', val: '597760'},
//                 {time: '202302221155', val: '591657'},
//                 {time: '202302221200', val: '577307'},
//                 {time: '202302221205', val: '515362'},
//                 {time: '202302221210', val: '489562'},
//                 {time: '202302221215', val: '513593'},
//                 {time: '202302221220', val: '512811'},
//                 {time: '202302221225', val: '574287'},
//                 {time: '202302221230', val: '531401'},
//                 {time: '202302221235', val: '549412'},
//                 {time: '202302221240', val: '551297'},
//                 {time: '202302221245', val: '561501'},
//                 {time: '202302221250', val: '577528'},
//                 {time: '202302221255', val: '568528'},
//                 {time: '202302221300', val: '579359'},
//                 {time: '202302221305', val: '567484'},
//                 {time: '202302221310', val: '568019'},
//                 {time: '202302221315', val: '553271'},
//                 {time: '202302221320', val: '547595'},
//                 {time: '202302221325', val: '553186'},
//                 {time: '202302221330', val: '559902'},
//                 {time: '202302221335', val: '570315'},
//                 {time: '202302221340', val: '587902'},
//                 {time: '202302221345', val: '574281'},
//                 {time: '202302221350', val: '587992'},
//                 {time: '202302221355', val: '604798'},
//                 {time: '202302221400', val: '591559'},
//                 {time: '202302221405', val: '575457'},
//                 {time: '202302221410', val: '584311'},
//                 {time: '202302221415', val: '603827'},
//                 {time: '202302221420', val: '614036'},
//                 {time: '202302221425', val: '668726'},
//                 {time: '202302221430', val: '630909'},
//                 {time: '202302221435', val: '625099'},
//                 {time: '202302221440', val: '628606'},
//                 {time: '202302221445', val: '639909'},
//                 {time: '202302221450', val: '659127'},
//                 {time: '202302221455', val: '661139'},
//                 {time: '202302221500', val: '640706'},
//                 {time: '202302221505', val: '648592'},
//                 {time: '202302221510', val: '654881'},
//                 {time: '202302221515', val: '648916'},
//                 {time: '202302221520', val: '641523'},
//                 {time: '202302221525', val: '659350'},
//                 {time: '202302221530', val: '648433'},
//                 {time: '202302221535', val: '663473'},
//                 {time: '202302221540', val: '657829'},
//                 {time: '202302221545', val: '651557'},
//                 {time: '202302221550', val: '658619'},
//                 {time: '202302221555', val: '661728'},
//                 {time: '202302221600', val: '676919'},
//                 {time: '202302221605', val: '658583'},
//                 {time: '202302221610', val: '663536'},
//                 {time: '202302221615', val: '642292'},
//                 {time: '202302221620', val: '648126'},
//                 {time: '202302221625', val: '675287'},
//                 {time: '202302221630', val: '658382'},
//                 {time: '202302221635', val: '640107'},
//                 {time: '202302221640', val: '650720'},
//                 {time: '202302221645', val: '654348'},
//                 {time: '202302221650', val: '654604'}
//             ],
//             knownSpiderCnt: [
//                 {time: '202302211650', val: '86821'},
//                 {time: '202302211655', val: '88624'},
//                 {time: '202302211700', val: '97726'},
//                 {time: '202302211705', val: '108759'},
//                 {time: '202302211710', val: '116325'},
//                 {time: '202302211715', val: '104038'},
//                 {time: '202302211720', val: '86503'},
//                 {time: '202302211725', val: '88142'},
//                 {time: '202302211730', val: '94684'},
//                 {time: '202302211735', val: '96046'},
//                 {time: '202302211740', val: '89244'},
//                 {time: '202302211745', val: '87488'},
//                 {time: '202302211750', val: '80817'},
//                 {time: '202302211755', val: '82517'},
//                 {time: '202302211800', val: '85720'},
//                 {time: '202302211805', val: '89794'},
//                 {time: '202302211810', val: '88682'},
//                 {time: '202302211815', val: '88871'},
//                 {time: '202302211820', val: '83787'},
//                 {time: '202302211825', val: '82253'},
//                 {time: '202302211830', val: '89422'},
//                 {time: '202302211835', val: '95490'},
//                 {time: '202302211840', val: '91704'},
//                 {time: '202302211845', val: '83495'},
//                 {time: '202302211850', val: '76603'},
//                 {time: '202302211855', val: '82147'},
//                 {time: '202302211900', val: '82364'},
//                 {time: '202302211905', val: '88244'},
//                 {time: '202302211910', val: '88919'},
//                 {time: '202302211915', val: '83902'},
//                 {time: '202302211920', val: '78061'},
//                 {time: '202302211925', val: '81246'},
//                 {time: '202302211930', val: '77532'},
//                 {time: '202302211935', val: '88745'},
//                 {time: '202302211940', val: '91053'},
//                 {time: '202302211945', val: '81745'},
//                 {time: '202302211950', val: '81206'},
//                 {time: '202302211955', val: '80252'},
//                 {time: '202302212000', val: '82570'},
//                 {time: '202302212005', val: '88289'},
//                 {time: '202302212010', val: '92756'},
//                 {time: '202302212015', val: '86508'},
//                 {time: '202302212020', val: '81854'},
//                 {time: '202302212025', val: '78541'},
//                 {time: '202302212030', val: '82156'},
//                 {time: '202302212035', val: '90309'},
//                 {time: '202302212040', val: '89226'},
//                 {time: '202302212045', val: '80964'},
//                 {time: '202302212050', val: '77292'},
//                 {time: '202302212055', val: '79644'},
//                 {time: '202302212100', val: '83850'},
//                 {time: '202302212105', val: '92150'},
//                 {time: '202302212110', val: '101450'},
//                 {time: '202302212115', val: '89316'},
//                 {time: '202302212120', val: '65424'},
//                 {time: '202302212125', val: '59679'},
//                 {time: '202302212130', val: '66650'},
//                 {time: '202302212135', val: '79322'},
//                 {time: '202302212140', val: '75851'},
//                 {time: '202302212145', val: '75566'},
//                 {time: '202302212150', val: '81358'},
//                 {time: '202302212155', val: '84436'},
//                 {time: '202302212200', val: '85203'},
//                 {time: '202302212205', val: '92947'},
//                 {time: '202302212210', val: '90877'},
//                 {time: '202302212215', val: '88834'},
//                 {time: '202302212220', val: '79291'},
//                 {time: '202302212225', val: '74326'},
//                 {time: '202302212230', val: '74855'},
//                 {time: '202302212235', val: '85911'},
//                 {time: '202302212240', val: '84145'},
//                 {time: '202302212245', val: '84177'},
//                 {time: '202302212250', val: '75830'},
//                 {time: '202302212255', val: '76828'},
//                 {time: '202302212300', val: '78909'},
//                 {time: '202302212305', val: '95147'},
//                 {time: '202302212310', val: '94109'},
//                 {time: '202302212315', val: '87753'},
//                 {time: '202302212320', val: '77129'},
//                 {time: '202302212325', val: '79001'},
//                 {time: '202302212330', val: '80130'},
//                 {time: '202302212335', val: '90480'},
//                 {time: '202302212340', val: '86840'},
//                 {time: '202302212345', val: '85548'},
//                 {time: '202302212350', val: '82051'},
//                 {time: '202302212355', val: '81320'},
//                 {time: '202302220000', val: '79160'},
//                 {time: '202302220005', val: '94243'},
//                 {time: '202302220010', val: '77707'},
//                 {time: '202302220015', val: '81911'},
//                 {time: '202302220020', val: '80448'},
//                 {time: '202302220025', val: '80172'},
//                 {time: '202302220030', val: '77484'},
//                 {time: '202302220035', val: '70355'},
//                 {time: '202302220040', val: '62167'},
//                 {time: '202302220045', val: '85313'},
//                 {time: '202302220050', val: '79797'},
//                 {time: '202302220055', val: '76432'},
//                 {time: '202302220100', val: '84567'},
//                 {time: '202302220105', val: '80065'},
//                 {time: '202302220110', val: '67612'},
//                 {time: '202302220115', val: '73193'},
//                 {time: '202302220120', val: '81205'},
//                 {time: '202302220125', val: '79903'},
//                 {time: '202302220130', val: '80958'},
//                 {time: '202302220135', val: '88590'},
//                 {time: '202302220140', val: '88923'},
//                 {time: '202302220145', val: '87203'},
//                 {time: '202302220150', val: '81441'},
//                 {time: '202302220155', val: '87026'},
//                 {time: '202302220200', val: '95829'},
//                 {time: '202302220205', val: '101158'},
//                 {time: '202302220210', val: '97521'},
//                 {time: '202302220215', val: '86279'},
//                 {time: '202302220220', val: '82281'},
//                 {time: '202302220225', val: '78263'},
//                 {time: '202302220230', val: '78051'},
//                 {time: '202302220235', val: '86390'},
//                 {time: '202302220240', val: '84046'},
//                 {time: '202302220245', val: '81059'},
//                 {time: '202302220250', val: '76062'},
//                 {time: '202302220255', val: '73501'},
//                 {time: '202302220300', val: '78132'},
//                 {time: '202302220305', val: '85023'},
//                 {time: '202302220310', val: '84184'},
//                 {time: '202302220315', val: '82172'},
//                 {time: '202302220320', val: '76961'},
//                 {time: '202302220325', val: '74072'},
//                 {time: '202302220330', val: '75347'},
//                 {time: '202302220335', val: '82849'},
//                 {time: '202302220340', val: '88526'},
//                 {time: '202302220345', val: '84611'},
//                 {time: '202302220350', val: '83552'},
//                 {time: '202302220355', val: '76355'},
//                 {time: '202302220400', val: '80790'},
//                 {time: '202302220405', val: '95854'},
//                 {time: '202302220410', val: '95437'},
//                 {time: '202302220415', val: '93606'},
//                 {time: '202302220420', val: '80600'},
//                 {time: '202302220425', val: '85575'},
//                 {time: '202302220430', val: '88822'},
//                 {time: '202302220435', val: '91782'},
//                 {time: '202302220440', val: '91422'},
//                 {time: '202302220445', val: '88942'},
//                 {time: '202302220450', val: '90110'},
//                 {time: '202302220455', val: '84946'},
//                 {time: '202302220500', val: '85307'},
//                 {time: '202302220505', val: '85841'},
//                 {time: '202302220510', val: '95263'},
//                 {time: '202302220515', val: '96167'},
//                 {time: '202302220520', val: '93356'},
//                 {time: '202302220525', val: '90696'},
//                 {time: '202302220530', val: '87013'},
//                 {time: '202302220535', val: '92961'},
//                 {time: '202302220540', val: '100917'},
//                 {time: '202302220545', val: '102724'},
//                 {time: '202302220550', val: '107786'},
//                 {time: '202302220555', val: '101692'},
//                 {time: '202302220600', val: '101048'},
//                 {time: '202302220605', val: '104246'},
//                 {time: '202302220610', val: '113075'},
//                 {time: '202302220615', val: '103261'},
//                 {time: '202302220620', val: '97367'},
//                 {time: '202302220625', val: '88649'},
//                 {time: '202302220630', val: '87672'},
//                 {time: '202302220635', val: '96556'},
//                 {time: '202302220640', val: '101315'},
//                 {time: '202302220645', val: '103182'},
//                 {time: '202302220650', val: '97651'},
//                 {time: '202302220655', val: '91127'},
//                 {time: '202302220700', val: '91579'},
//                 {time: '202302220705', val: '91964'},
//                 {time: '202302220710', val: '98266'},
//                 {time: '202302220715', val: '100031'},
//                 {time: '202302220720', val: '88578'},
//                 {time: '202302220725', val: '78956'},
//                 {time: '202302220730', val: '75758'},
//                 {time: '202302220735', val: '82017'},
//                 {time: '202302220740', val: '87265'},
//                 {time: '202302220745', val: '87898'},
//                 {time: '202302220750', val: '85540'},
//                 {time: '202302220755', val: '82389'},
//                 {time: '202302220800', val: '84774'},
//                 {time: '202302220805', val: '90705'},
//                 {time: '202302220810', val: '95699'},
//                 {time: '202302220815', val: '96208'},
//                 {time: '202302220820', val: '87845'},
//                 {time: '202302220825', val: '86672'},
//                 {time: '202302220830', val: '85932'},
//                 {time: '202302220835', val: '95580'},
//                 {time: '202302220840', val: '93993'},
//                 {time: '202302220845', val: '86600'},
//                 {time: '202302220850', val: '86851'},
//                 {time: '202302220855', val: '78403'},
//                 {time: '202302220900', val: '78972'},
//                 {time: '202302220905', val: '81291'},
//                 {time: '202302220910', val: '89778'},
//                 {time: '202302220915', val: '90905'},
//                 {time: '202302220920', val: '89790'},
//                 {time: '202302220925', val: '84699'},
//                 {time: '202302220930', val: '79978'},
//                 {time: '202302220935', val: '84363'},
//                 {time: '202302220940', val: '86187'},
//                 {time: '202302220945', val: '87455'},
//                 {time: '202302220950', val: '85415'},
//                 {time: '202302220955', val: '79913'},
//                 {time: '202302221000', val: '77889'},
//                 {time: '202302221005', val: '85177'},
//                 {time: '202302221010', val: '90748'},
//                 {time: '202302221015', val: '84770'},
//                 {time: '202302221020', val: '81890'},
//                 {time: '202302221025', val: '75141'},
//                 {time: '202302221030', val: '73657'},
//                 {time: '202302221035', val: '79946'},
//                 {time: '202302221040', val: '86422'},
//                 {time: '202302221045', val: '88728'},
//                 {time: '202302221050', val: '83845'},
//                 {time: '202302221055', val: '76716'},
//                 {time: '202302221100', val: '83606'},
//                 {time: '202302221105', val: '84311'},
//                 {time: '202302221110', val: '88619'},
//                 {time: '202302221115', val: '87702'},
//                 {time: '202302221120', val: '82964'},
//                 {time: '202302221125', val: '74857'},
//                 {time: '202302221130', val: '75377'},
//                 {time: '202302221135', val: '80414'},
//                 {time: '202302221140', val: '84185'},
//                 {time: '202302221145', val: '85239'},
//                 {time: '202302221150', val: '88205'},
//                 {time: '202302221155', val: '82882'},
//                 {time: '202302221200', val: '79166'},
//                 {time: '202302221205', val: '80579'},
//                 {time: '202302221210', val: '84438'},
//                 {time: '202302221215', val: '92094'},
//                 {time: '202302221220', val: '91819'},
//                 {time: '202302221225', val: '82402'},
//                 {time: '202302221230', val: '79276'},
//                 {time: '202302221235', val: '81820'},
//                 {time: '202302221240', val: '94185'},
//                 {time: '202302221245', val: '88033'},
//                 {time: '202302221250', val: '90733'},
//                 {time: '202302221255', val: '87719'},
//                 {time: '202302221300', val: '77363'},
//                 {time: '202302221305', val: '86739'},
//                 {time: '202302221310', val: '88497'},
//                 {time: '202302221315', val: '89776'},
//                 {time: '202302221320', val: '88841'},
//                 {time: '202302221325', val: '82536'},
//                 {time: '202302221330', val: '75599'},
//                 {time: '202302221335', val: '76684'},
//                 {time: '202302221340', val: '82977'},
//                 {time: '202302221345', val: '82067'},
//                 {time: '202302221350', val: '82351'},
//                 {time: '202302221355', val: '80133'},
//                 {time: '202302221400', val: '53000'},
//                 {time: '202302221405', val: '71422'},
//                 {time: '202302221410', val: '97650'},
//                 {time: '202302221415', val: '86314'},
//                 {time: '202302221420', val: '77391'},
//                 {time: '202302221425', val: '70679'},
//                 {time: '202302221430', val: '73767'},
//                 {time: '202302221435', val: '82910'},
//                 {time: '202302221440', val: '83393'},
//                 {time: '202302221445', val: '80583'},
//                 {time: '202302221450', val: '76128'},
//                 {time: '202302221455', val: '75659'},
//                 {time: '202302221500', val: '77483'},
//                 {time: '202302221505', val: '86840'},
//                 {time: '202302221510', val: '86415'},
//                 {time: '202302221515', val: '81479'},
//                 {time: '202302221520', val: '72636'},
//                 {time: '202302221525', val: '69569'},
//                 {time: '202302221530', val: '72419'},
//                 {time: '202302221535', val: '80177'},
//                 {time: '202302221540', val: '83488'},
//                 {time: '202302221545', val: '81592'},
//                 {time: '202302221550', val: '78958'},
//                 {time: '202302221555', val: '71315'},
//                 {time: '202302221600', val: '71465'},
//                 {time: '202302221605', val: '73222'},
//                 {time: '202302221610', val: '81116'},
//                 {time: '202302221615', val: '87681'},
//                 {time: '202302221620', val: '87259'},
//                 {time: '202302221625', val: '84411'},
//                 {time: '202302221630', val: '68280'},
//                 {time: '202302221635', val: '73604'},
//                 {time: '202302221640', val: '82891'},
//                 {time: '202302221645', val: '82311'},
//                 {time: '202302221650', val: '80248'}
//             ]
//         }
//     };
//     return new Promise(r => {
//         setTimeout(() => {
//             r(data);
//         }, 1000);
//     });
// // };


export const getBusinessAnalyseRiskEvent = p => get('/api/v1/analysisReport/alarmEvent', p);
// export const getBusinessAnalyseRiskEvent = p => {
//     console.log('getBusinessAnalyseRiskEvent');
//     return new Promise(r => {
//         setTimeout(() => {
//             r({
//                 res: 0,
//                 data: [
//                     {
//                         id: 1,
//                         rule: 'black_cookie_dr4=10',
//                         feature: 'pv',
//                         subid: 'h5',
//                         content: '当前值: 2475\n前12小时平均值: 514\n昨天同期平均值: 0',
//                         startTime: '202302220943',
//                         endTime: '202302220948'
//                     },
//                     {
//                         id: 2,
//                         rule: 'black_cookie_dr4=10',
//                         subid: 'app',
//                         feature: 'ipCnt',
//                         content: '当前值: 2475\n前12小时平均值: 514\n昨天同期平均值: 0',
//                         startTime: '202302220843',
//                         endTime: '202302220848'
//                     }
//                 ]
//             });
//         }, 1000);
//     });
// };

export const getBusinessAnalyseGroupList = p => get('/api/v1/analysisReport/groupSummary', p);
export const getBusinessAnalyseGroup = p => get('/api/v1/analysisReport/group', p);
// export const getBusinessAnalyseGroup = p => {
//     console.log('getBusinessAnalyseGroup');
//     return new Promise(r => {
//         setTimeout(() => {
//             const data = [
//                 {
//                     group: '1',
//                     ip: '1.192.217.65',
//                     uid: '5950523584',
//                     pv: '33',
//                     uks: '33',
//                     ks: '0',
//                     subids: "['app']",
//                     location: '河南|郑州|CN',
//                     rulehit: "[',BlackJa3']"
//                 },
//                 {
//                     group: '1',
//                     ip: '1.192.217.65',
//                     uid: '5987131312',
//                     pv: '41',
//                     uks: '41',
//                     ks: '0',
//                     subids: "['app']",
//                     location: '河南|郑州|CN',
//                     rulehit: "[',BlackJa3']"
//                 },
//                 {
//                     group: '1',
//                     ip: '1.192.217.65',
//                     uid: '6384698961',
//                     pv: '5',
//                     uks: '5',
//                     ks: '0',
//                     subids: "['app']",
//                     location: '河南|郑州|CN',
//                     rulehit: "[',BlackJa3']"
//                 },
//                 {
//                     group: '1',
//                     ip: '1.193.121.75',
//                     uid: '2105882147',
//                     pv: '8',
//                     uks: '0',
//                     ks: '0',
//                     subids: "['h5']",
//                     location: '河南|郑州|CN',
//                     rulehit: "['']"
//                 },
//                 {
//                     group: '1',
//                     ip: '1.193.121.75',
//                     uid: '3418086194',
//                     pv: '2',
//                     uks: '2',
//                     ks: '0',
//                     subids: "['h5']",
//                     location: '河南|郑州|CN',
//                     rulehit: "[',SuRiskScoreUks,RuleEngineBlackUid_uid_group_2094_level_7']"
//                 },
//                 {
//                     group: '1',
//                     ip: '1.85.19.42',
//                     uid: '1098542185',
//                     pv: '70',
//                     uks: '0',
//                     ks: '0',
//                     subids: "['app']",
//                     location: '陕西|西安|CN',
//                     rulehit: "['']"
//                 },
//                 {
//                     group: '1',
//                     ip: '101.229.127.63',
//                     uid: '5886845257',
//                     pv: '144',
//                     uks: '144',
//                     ks: '0',
//                     subids: "['app']",
//                     location: '上海|上海|CN',
//                     rulehit: "[',BlackJa3']"
//                 },
//                 {
//                     group: '1',
//                     ip: '103.251.98.118',
//                     uid: '5464161515',
//                     pv: '5',
//                     uks: '0',
//                     ks: '0',
//                     subids: "['app']",
//                     location: '广西|None|CN',
//                     rulehit: "['']"
//                 },
//                 {
//                     group: '1',
//                     ip: '106.114.150.240',
//                     uid: '1460878683',
//                     pv: '1',
//                     uks: '1',
//                     ks: '0',
//                     subids: "['app']",
//                     location: '河北|石家庄|CN',
//                     rulehit: "[',SuRiskScoreUks']"
//                 },
//                 {
//                     group: '1',
//                     ip: '106.114.150.240',
//                     uid: '5376101200',
//                     pv: '14',
//                     uks: '0',
//                     ks: '0',
//                     subids: "['app']",
//                     location: '河北|石家庄|CN',
//                     rulehit: "['']"
//                 },
//                 {
//                     group: '1',
//                     ip: '106.114.150.240',
//                     uid: '5960550418',
//                     pv: '34',
//                     uks: '34',
//                     ks: '0',
//                     subids: "['h5','app']",
//                     location: '河北|石家庄|CN',
//                     rulehit: "[',SuRiskScoreUks,BlackJa3',',BlackJa3']"
//                 },
//                 {
//                     group: '1',
//                     ip: '106.114.150.240',
//                     uid: '6388006418',
//                     pv: '700',
//                     uks: '698',
//                     ks: '0',
//                     subids: "['h5','app']",
//                     location: '河北|石家庄|CN',
//                     rulehit: "[',SuRiskScoreUks',',SuRiskScoreUks,BlackJa3',',BlackJa3','']"
//                 },
//                 {
//                     group: '1',
//                     ip: '106.119.218.56',
//                     uid: '5014016525',
//                     pv: '322',
//                     uks: '322',
//                     ks: '0',
//                     subids: "['app']",
//                     location: '河北|唐山|CN',
//                     rulehit: "[',BlackJa3']"
//                 },
//                 {
//                     group: '1',
//                     ip: '106.122.11.29',
//                     uid: '6053052973',
//                     pv: '396',
//                     uks: '388',
//                     ks: '0',
//                     subids: "['app']",
//                     location: '福建|None|CN',
//                     rulehit: "[',SuRiskScoreUks','']"
//                 },
//                 {
//                     group: '1',
//                     ip: '106.122.112.116',
//                     uid: '6351872818',
//                     pv: '117',
//                     uks: '117',
//                     ks: '0',
//                     subids: "['app']",
//                     location: '福建|None|CN',
//                     rulehit: "[',SuRiskScoreUks,BlackJa3',',BlackJa3']"
//                 },
//                 {
//                     group: '1',
//                     ip: '106.122.117.0',
//                     uid: '2252486288',
//                     pv: '32',
//                     uks: '30',
//                     ks: '0',
//                     subids: "['app']",
//                     location: '福建|None|CN',
//                     rulehit: "[',SuRiskScoreUks','']"
//                 },
//                 {
//                     group: '1',
//                     ip: '106.122.125.122',
//                     uid: '4861927976',
//                     pv: '5',
//                     uks: '5',
//                     ks: '0',
//                     subids: "['h5','app']",
//                     location: '福建|None|CN',
//                     rulehit: "[',SuRiskScoreUks']"
//                 },
//                 {
//                     group: '1',
//                     ip: '106.122.125.122',
//                     uid: '6337257671',
//                     pv: '1',
//                     uks: '0',
//                     ks: '0',
//                     subids: "['app']",
//                     location: '福建|None|CN',
//                     rulehit: "['']"
//                 },
//                 {
//                     group: '1',
//                     ip: '106.122.13.165',
//                     uid: '2192409682',
//                     pv: '18',
//                     uks: '0',
//                     ks: '0',
//                     subids: "['app']",
//                     location: '福建|None|CN',
//                     rulehit: "['']"
//                 },
//                 {
//                     group: '1',
//                     ip: '106.122.13.50',
//                     uid: '6038205182',
//                     pv: '73',
//                     uks: '0',
//                     ks: '0',
//                     subids: "['app']",
//                     location: '福建|None|CN',
//                     rulehit: "['']"
//                 },
//                 {
//                     group: '1',
//                     ip: '106.122.13.50',
//                     uid: '6363184259',
//                     pv: '33',
//                     uks: '0',
//                     ks: '0',
//                     subids: "['app']",
//                     location: '福建|None|CN',
//                     rulehit: "['']"
//                 },
//                 {
//                     group: '1',
//                     ip: '106.122.14.246',
//                     uid: '6352028055',
//                     pv: '188',
//                     uks: '0',
//                     ks: '0',
//                     subids: "['app']",
//                     location: '福建|None|CN',
//                     rulehit: "['']"
//                 },
//                 {
//                     group: '1',
//                     ip: '106.122.14.246',
//                     uid: '6355741895',
//                     pv: '136',
//                     uks: '0',
//                     ks: '0',
//                     subids: "['app']",
//                     location: '福建|None|CN',
//                     rulehit: "['']"
//                 },
//                 {
//                     group: '1',
//                     ip: '106.122.14.246',
//                     uid: '6363204484',
//                     pv: '101',
//                     uks: '0',
//                     ks: '0',
//                     subids: "['app']",
//                     location: '福建|None|CN',
//                     rulehit: "['']"
//                 },
//                 {
//                     group: '1',
//                     ip: '106.122.17.120',
//                     uid: '6055041494',
//                     pv: '36',
//                     uks: '0',
//                     ks: '0',
//                     subids: "['app']",
//                     location: '福建|None|CN',
//                     rulehit: "['']"
//                 },
//                 {
//                     group: '1',
//                     ip: '106.122.17.120',
//                     uid: '6353275194',
//                     pv: '38',
//                     uks: '0',
//                     ks: '0',
//                     subids: "['app']",
//                     location: '福建|None|CN',
//                     rulehit: "['']"
//                 },
//                 {
//                     group: '1',
//                     ip: '106.122.17.120',
//                     uid: '6356880749',
//                     pv: '60',
//                     uks: '0',
//                     ks: '0',
//                     subids: "['app']",
//                     location: '福建|None|CN',
//                     rulehit: "['']"
//                 },
//                 {
//                     group: '1',
//                     ip: '106.122.25.185',
//                     uid: '6047900871',
//                     pv: '599',
//                     uks: '0',
//                     ks: '0',
//                     subids: "['app']",
//                     location: '福建|None|CN',
//                     rulehit: "['']"
//                 },
//                 {
//                     group: '1',
//                     ip: '106.122.25.185',
//                     uid: '6363128496',
//                     pv: '732',
//                     uks: '0',
//                     ks: '0',
//                     subids: "['app']",
//                     location: '福建|None|CN',
//                     rulehit: "['']"
//                 },
//                 {
//                     group: '1',
//                     ip: '106.122.25.185',
//                     uid: '6363193821',
//                     pv: '12',
//                     uks: '0',
//                     ks: '0',
//                     subids: "['app']",
//                     location: '福建|None|CN',
//                     rulehit: "['']"
//                 }
//             ];
//             r({res: 0, data});
//         }, 1000);
//     });
// };

export const getBusinessAnalyseLayer = p => get('/api/v1/analysisReport/idLayer', p);
// export const getBusinessAnalyseLayer = p => {
//     console.log('getBusinessAnalyseLayer');
//     return new Promise(r => {
//         setTimeout(() => {
//             const data1 = [
//                 {
//                     subid: "('app','h5')",
//                     idType: 'ip',
//                     quantile: '0',
//                     idCnt: 5295,
//                     layer: 'pv<2',
//                     layerPv: 5295,
//                     cntShare: 0.100208,
//                     pvShare: 0.00051,
//                     spiderRate: 0.132956
//                 },
//                 {
//                     subid: "('app','h5')",
//                     idType: 'ip',
//                     quantile: '40',
//                     idCnt: 5395,
//                     layer: 'pv>=13 and pv<22',
//                     layerPv: 89062,
//                     cntShare: 0.102101,
//                     pvShare: 0.008586,
//                     spiderRate: 0.144854
//                 },
//                 {
//                     subid: "('app','h5')",
//                     idType: 'ip',
//                     quantile: '80',
//                     idCnt: 5381,
//                     layer: 'pv>=184 and pv<477',
//                     layerPv: 1626839,
//                     cntShare: 0.101836,
//                     pvShare: 0.156836,
//                     spiderRate: 0.27615
//                 },
//                 {
//                     subid: "('app','h5')",
//                     idType: 'ip',
//                     quantile: '10',
//                     idCnt: 5467,
//                     layer: 'pv>=2 and pv<4',
//                     layerPv: 13158,
//                     cntShare: 0.103463,
//                     pvShare: 0.001269,
//                     spiderRate: 0.131631
//                 },
//                 {
//                     subid: "('app','h5')",
//                     idType: 'ip',
//                     quantile: '50',
//                     idCnt: 5212,
//                     layer: 'pv>=22 and pv<41',
//                     layerPv: 155036,
//                     cntShare: 0.098637,
//                     pvShare: 0.014946,
//                     spiderRate: 0.191581
//                 },
//                 {
//                     subid: "('app','h5')",
//                     idType: 'ip',
//                     quantile: '99',
//                     idCnt: 484,
//                     layer: 'pv>=2728',
//                     layerPv: 2429923,
//                     cntShare: 0.00916,
//                     pvShare: 0.234258,
//                     spiderRate: 0.527855
//                 },
//                 {
//                     subid: "('app','h5')",
//                     idType: 'ip',
//                     quantile: '20',
//                     idCnt: 5487,
//                     layer: 'pv>=4 and pv<8',
//                     layerPv: 29197,
//                     cntShare: 0.103842,
//                     pvShare: 0.002815,
//                     spiderRate: 0.150358
//                 },
//                 {
//                     subid: "('app','h5')",
//                     idType: 'ip',
//                     quantile: '60',
//                     idCnt: 5390,
//                     layer: 'pv>=41 and pv<87',
//                     layerPv: 324282,
//                     cntShare: 0.102006,
//                     pvShare: 0.031263,
//                     spiderRate: 0.241342
//                 },
//                 {
//                     subid: "('app','h5')",
//                     idType: 'ip',
//                     quantile: '90',
//                     idCnt: 2652,
//                     layer: 'pv>=477 and pv<920',
//                     layerPv: 1755381,
//                     cntShare: 0.050189,
//                     pvShare: 0.169228,
//                     spiderRate: 0.314176
//                 },
//                 {
//                     subid: "('app','h5')",
//                     idType: 'ip',
//                     quantile: '30',
//                     idCnt: 5105,
//                     layer: 'pv>=8 and pv<13',
//                     layerPv: 50424,
//                     cntShare: 0.096612,
//                     pvShare: 0.004861,
//                     spiderRate: 0.122759
//                 },
//                 {
//                     subid: "('app','h5')",
//                     idType: 'ip',
//                     quantile: '70',
//                     idCnt: 4767,
//                     layer: 'pv>=87 and pv<184',
//                     layerPv: 612027,
//                     cntShare: 0.090216,
//                     pvShare: 0.059003,
//                     spiderRate: 0.261034
//                 },
//                 {
//                     subid: "('app','h5')",
//                     idType: 'ip',
//                     quantile: '95',
//                     idCnt: 2205,
//                     layer: 'pv>=920 and pv<2728',
//                     layerPv: 3282238,
//                     cntShare: 0.04173,
//                     pvShare: 0.316425,
//                     spiderRate: 0.34761
//                 }
//             ];
//             const data2 = [
//                 {
//                     subid: "('app','h5')",
//                     idType: 'uid',
//                     quantile: '0',
//                     idCnt: 2440,
//                     layer: 'pv<2',
//                     layerPv: 2440,
//                     cntShare: 0.069665,
//                     pvShare: 0.000235,
//                     spiderRate: 0.096311
//                 },
//                 {
//                     subid: "('app','h5')",
//                     idType: 'uid',
//                     quantile: '30',
//                     idCnt: 3499,
//                     layer: 'pv>=11 and pv<18',
//                     layerPv: 47712,
//                     cntShare: 0.0999,
//                     pvShare: 0.0046,
//                     spiderRate: 0.088384
//                 },
//                 {
//                     subid: "('app','h5')",
//                     idType: 'uid',
//                     quantile: '95',
//                     idCnt: 1390,
//                     layer: 'pv>=1471 and pv<3731',
//                     layerPv: 3060797,
//                     cntShare: 0.039686,
//                     pvShare: 0.295077,
//                     spiderRate: 0.401832
//                 },
//                 {
//                     subid: "('app','h5')",
//                     idType: 'uid',
//                     quantile: '70',
//                     idCnt: 3482,
//                     layer: 'pv>=162 and pv<349',
//                     layerPv: 852951,
//                     cntShare: 0.099415,
//                     pvShare: 0.082229,
//                     spiderRate: 0.280676
//                 },
//                 {
//                     subid: "('app','h5')",
//                     idType: 'uid',
//                     quantile: '40',
//                     idCnt: 3633,
//                     layer: 'pv>=18 and pv<32',
//                     layerPv: 85653,
//                     cntShare: 0.103726,
//                     pvShare: 0.008257,
//                     spiderRate: 0.129686
//                 },
//                 {
//                     subid: "('app','h5')",
//                     idType: 'uid',
//                     quantile: '10',
//                     idCnt: 4393,
//                     layer: 'pv>=2 and pv<6',
//                     layerPv: 14046,
//                     cntShare: 0.125425,
//                     pvShare: 0.001354,
//                     spiderRate: 0.114766
//                 },
//                 {
//                     subid: "('app','h5')",
//                     idType: 'uid',
//                     quantile: '50',
//                     idCnt: 3616,
//                     layer: 'pv>=32 and pv<72',
//                     layerPv: 172035,
//                     cntShare: 0.103241,
//                     pvShare: 0.016585,
//                     spiderRate: 0.192711
//                 },
//                 {
//                     subid: "('app','h5')",
//                     idType: 'uid',
//                     quantile: '80',
//                     idCnt: 3749,
//                     layer: 'pv>=349 and pv<847',
//                     layerPv: 2054330,
//                     cntShare: 0.107038,
//                     pvShare: 0.198049,
//                     spiderRate: 0.296221
//                 },
//                 {
//                     subid: "('app','h5')",
//                     idType: 'uid',
//                     quantile: '99',
//                     idCnt: 282,
//                     layer: 'pv>=3731',
//                     layerPv: 1632682,
//                     cntShare: 0.008051,
//                     pvShare: 0.157399,
//                     spiderRate: 0.498376
//                 },
//                 {
//                     subid: "('app','h5')",
//                     idType: 'uid',
//                     quantile: '20',
//                     idCnt: 3304,
//                     layer: 'pv>=6 and pv<11',
//                     layerPv: 26567,
//                     cntShare: 0.094333,
//                     pvShare: 0.002561,
//                     spiderRate: 0.104528
//                 },
//                 {
//                     subid: "('app','h5')",
//                     idType: 'uid',
//                     quantile: '60',
//                     idCnt: 3400,
//                     layer: 'pv>=72 and pv<162',
//                     layerPv: 376572,
//                     cntShare: 0.097074,
//                     pvShare: 0.036304,
//                     spiderRate: 0.253933
//                 },
//                 {
//                     subid: "('app','h5')",
//                     idType: 'uid',
//                     quantile: '90',
//                     idCnt: 1837,
//                     layer: 'pv>=847 and pv<1471',
//                     layerPv: 2047077,
//                     cntShare: 0.052448,
//                     pvShare: 0.197349,
//                     spiderRate: 0.331057
//                 }
//             ];

//             r({
//                 res: 0,
//                 data: p.idType === 'ip' ? data1 : data2
//             });
//         }, 1000);
//     });
// };

export const getBusinessAnalyseLayerTop = p => get('/api/v1/analysisReport/idCase', p);
// export const getBusinessAnalyseLayerTop = p => {
//     console.log('getBusinessAnalyseLayerTop');
//     const data = [
// 		{
// 			"subid": "('app','h5')",
// 			"idType": "ip",
// 			"idValue": "1.199.129.51",
// 			"riskLevel": "highRisk",
// 			"risk10Pv": 19305,
// 			"pv": 19557,
// 			"urlCnt": 89,
// 			"urlDemo": "['https://zhidao.baidu.com/nchat/api/getorderlist?htj_to=20$514916769016505442925248721116770693942168491&htj_vw=021170451490000000000000000000000000000000000000000000008401ff80037E15A8D10A6B053C25BE092CE564B948C:FG%3D10000000000000&htj_jt=31%2524eyJrIj4iNyI0Iix5IkciQEZISUNKTklQT1JPVCJJIkFqIjwiNTs9Pjg%252FQz5FREdESSI%252BIjYzIlEiSlBSU01UWDM6NTg5OyIzIit5IkYiQz9AQSI%252FIjkiUSJMSE5KUVciLCJsIj4ibXpXVG1DTz5EKT9nbGo8Z0pZQ2NfVHROcT44bTN0Vm41LlJeMW40YGJwODZTWUxNTHlPQVNzPEQvdHVXS1JJLT5bOGN2VSl2V3ViLGdbW0BrbkdmbHFUTDpSblgyZzlOSU51QncpV1hGXEhHeilpLlktPD45SkA8NGpETm05cF0xPSw6XGMqNTNHSClkakc2eGIyX0BuYjYtN3RNajpMWmdXPW9UWTReVHZHXXR5aE1BLk5kSUN2LzxPd3JDejUtaGtzdHc%252BYXNCNylbX3Q1b3owLWllYmA2RVRqM3d1SDtxal5PWz5NUHR5M0FnazlAa0lcNT5tcVFkUjhWNFgvPGBAKl01WE9eV3ouMEVGL0YtNlkpZ0IyNHhkVDg5c1RVZzgqbzItbj1VQV5jSWMqLDYyKUg2L0s5eGBNKVRsTm9aSk8qa29YcHYtVkhqZ1xHRmk3L011PmxWZ0wzTk1xOW1NTF9DYTRhXl1xYitsXT1tLStkMyo1MmU%252FRmtUdElQZzxfQS91REQrRTJJc11eMDssTz5gQ2Q0Mm1QWTlTXGxfP09dXjZNM2Q%252FaTdnOkROL2JdNyorPlI5ajJzSGc3XnxsVj54WC92K11zYy0%252BZy08O2YtNW47ZzVWYnhwK1U8VnFbcy16RU93cCpqT3xFRXxITi0uKk1UV1ExZDo8OWs4aDhtb0E9ckRwc0pDSEopTyJ9&htj_app=universe&listtype=payorder&subsidyTokenVersion=v1&pn=0&rn=20&verifyCodeDs=B6d1f8qWYbyyV0Z%2B2QBQtEQlj9bhGmIR5o%2Fo0iMgHx85L%2B0uGGeD9%2BZe%2B4cqU9nnyIY9fHtu8gbNz%2B0v%2FZJa6JTiPY4Y4uk3onmGNyfrZNBuK1h%2B4c1n15x1HIXjG%2FaXY4xEXMpJfla8EUiJmETa7WuhV8pv9XPTcHBbbpU7YCwiZ%2B%2BBR8jN2roqaEETV0D1uDVd20HUlrhV4E3tp3mNyTYiuoCOeEftBuK342Somrdi%2F%2BQzvgEF7pfr0Ht4vumKpLSHwue3aMkgI%2BoENX4rEQFTUcquE0eUroc7CuSM9B72lXxgnWBFVY%2FQRUimlNZinsI1ZFkr7rTh4Kv1pa%2BqXbH4IpMbHKJv1moGR48LkTdFNPbDJleynwZGnquyALa07HZ%2FGRD1ZpKQL3MUMHBFBqG%2F8e%2FVu8SvRwAGxHb1GL%2BKhZ2N6t4IvBkICoqtmJt%2ByQNhQ%2FrIk1PmVp%2F3pBlik3J2p4jbXcA70hQjgSKpMrkKbUwL9ZNBkFQFyXO92p0yJyS3%2BVk5JeN4V8nzB2bz3EfzHF8EnNiofibvgJiuvR9czqxMrCH83oFhiwJ3i8BBQWkny3flaM5G0iHfAz6Tnd5rPXEEai4OBsIqUy2QUQwpUcDjB5bxzf9XHvGfbUzcyF8JFUl%2FxXruUL1XQ%2Bln%2BTFRRDB434gTPTeWrYwn03RvoVhADTIzCbeUH1yeqXuoKUtHMIPkOGed3LHUAAVoSKgFSoIydLOIEbIH%2Flb8l2pO0bCwfBbFyNw8KXmXXH%2BgnrpfwbXIFXh3agg3nj5MST4pRz5ghCE1N5SrBbGxI4rN%2BYnVfEyuBtDmbqXV%2B4eWZo4nKNTfpKhoPptEelwzMfujceiozZa0FHne6nNmVsCBRYwe44LB8SAHgu%2B%2FdRJ6qQVexLzSDtYVVFRr6nkZESu3tU8IfwZBFsALCPRCvFpiEU25jyWAm9adGBkSaH%2FOvMNucpxpvEFKm3xIEYFHHVE9QhNY0pYbP%2FNk7asDeFEW3nJxHO%2FrFwQB0zvWsL9%2FS1ncHJuIcVlTMSRfwzWR%2Fvg1oCdJwQmL8V4%2BUKS1R2xPTT1BEDRknQCsicsw1Gvotc6JR3MNmhcWysw4bJuzlohD6mhqJJCPYjxZrZ0CezrQCa6gm0kE0kfU8yP4zlMaEUVQgNNlF9wPHo2rGDeERnpvb0zVCCL7l21qNFtBOqj21iiv6PiMmq0hAh6HJr6oSqPriT4DLTUsraupoIHivXObPReT3TV3Odc6d0ermGTlF7ddcc9jfpDFvMibzzV6ZIacJjE3hr3tUOTDLDVJZx%2Ff4eGa6N9stAnyCujMBRwZcGRESfVQQZ8d28MZTs5LA1ZG2ZKoBHzpoQ1BKLn2tOzAOoY0q6COePJAjINNSBquYbtlUTAx45m%2FPyNw9OqqtjKIT7%2Bn2%2Fiu6%2BsDdc3j8fze1GA%2B6l3Bi29GHGxUTRQ9SF6tWtIQuwd2UOBV0lgYTn0shpaR27njJYiqNgoAYshADU9DdXmJXU%2FBM1jeGbeiw5XuWnwd75G3mgycCR5luKC%2FK%2Bs15moy0ZbzvKK%2BRIqVKMGI5cmCGp%2B2wupBxfhPcY3Q2LWwgXpHljAzhhqZRh6W4Yku27Oil7ztfT0TqmUXC%2FsN1USuhbcb7go2%2FXhLUHWOpAyVNzHDztThk1acoYCu9Tjp3Xm6FlumJQXeaeM%2B3fFv6BUocQr%2FIjaQDD4t55mt9UwRMDBhbsyM%2FO0l32Y2YVysM5LCUWhNprms15ukSlsUsk8H5hBJIE7nbmhlWfRg1D2cEvuTey2j%2F4oGgsoAQL0zXuKx4odJnrXKbV02Feycqxu3b0wnoAbTTKFEm9r7HNnlslUefBLljqf8md6U%2BSDrdqMxkFWKmJHNVBcAEHw3j5rq6WMa1hBtVuXdNu5dhxnXC9Ki5jthKQkVWYITqdP2HcIetR9qNKem2aHu22x3AW1VVlZ90e%2FIcrWHM3o2o3v3YqvpfHOti9QC4E4ydDXMhEjNKCvn4g6UOM48IZelqJ8aEaWDT0T%2BiFZNgwqpIEJMWqOzD3%2BPhSiG5ivXMGgRCcmcVh11vpm9VwQzH3UU20IFoi69TdWH6gd6lq25EQNwl7y4CtaZoGnaOrgtUvg9IUYAg1wV4khSnTqivFYfvKKs4%2FXl16TEvDAtQWvu7I6SXXfS%2FPja2%2B0v1c8ujqyY1UVGey1SSS6Ang%3D%3D&verifyCodeToken=13984Gq%2Bl9yq7jZr6Sk%2B0hGgO01j6IC%2B4pzIV7K%2BGXl45A0b7iM0dWlJnOejfy0zG1QwaFMBxQj5tYJC3JByab5sla6I36mv1BZi8mPDrB7MGiETzjdFx4IO6bKj943y6jiy&verifyInfo=eyJjbGlja0RpZmYiOjB9&url=%2Fnchat%2Fapi%2Fgetorderlist']",
// 			"acsOkRate": 0.004142,
// 			"absrOkRate": 0.499207,
// 			"ts": "[[\"202302220220\",161],[\"202302220330\",160],[\"202302222210\",244],[\"202302222045\",319],[\"202302220050\",155],[\"202302222340\",242],[\"202302220145\",157],[\"202302220255\",156],[\"202302222135\",319],[\"202302220015\",160],[\"202302222305\",240],[\"202302220110\",161],[\"202302222320\",234],[\"202302222105\",307],[\"202302220200\",161],[\"202302222230\",235],[\"202302220350\",161],[\"202302220035\",157],[\"202302220405\",164],[\"202302222245\",239],[\"202302220125\",159],[\"202302222155\",295],[\"202302220315\",164],[\"202302222345\",246],[\"202302220055\",158],[\"202302220335\",157],[\"202302222215\",301],[\"202302220225\",156],[\"202302222040\",311],[\"202302222300\",235],[\"202302220010\",161],[\"202302220250\",160],[\"202302222130\",312],[\"202302220140\",162],[\"202302222100\",319],[\"202302222235\",237],[\"202302220355\",161],[\"202302220205\",164],[\"202302222325\",238],[\"202302220115\",162],[\"202302222150\",311],[\"202302220310\",162],[\"202302220120\",163],[\"202302220400\",161],[\"202302222240\",236],[\"202302220030\",161],[\"202302220155\",157],[\"202302220245\",158],[\"202302222125\",331],[\"202302220005\",160],[\"202302222315\",248],[\"202302221904\",3],[\"202302222055\",317],[\"202302220230\",159],[\"202302220320\",164],[\"202302222200\",322],[\"202302220040\",166],[\"202302222350\",238],[\"202302220025\",155],[\"202302220415\",128],[\"202302222255\",232],[\"202302220135\",163],[\"202302222145\",323],[\"202302220305\",163],[\"202302222034\",8],[\"202302220100\",162],[\"202302222330\",246],[\"202302220210\",159],[\"202302222220\",259],[\"202302220340\",159],[\"202302222115\",314],[\"202302222310\",244],[\"202302220000\",157],[\"202302221905\",24],[\"202302220240\",161],[\"202302222120\",280],[\"202302220150\",157],[\"202302222355\",242],[\"202302220045\",160],[\"202302222050\",312],[\"202302220325\",162],[\"202302222205\",306],[\"202302220235\",160],[\"202302222140\",314],[\"202302220300\",162],[\"202302220130\",156],[\"202302222035\",257],[\"202302220410\",158],[\"202302222250\",244],[\"202302220020\",158],[\"202302222225\",239],[\"202302220345\",160],[\"202302220215\",159],[\"202302222110\",311],[\"202302222335\",234],[\"202302220105\",162]]"
// 		},
// 		{
// 			"subid": "('app','h5')",
// 			"idType": "ip",
// 			"idValue": "117.152.26.195",
// 			"riskLevel": "highRisk",
// 			"risk10Pv": 15470,
// 			"pv": 16500,
// 			"urlCnt": 16498,
// 			"urlDemo": "['https://zhidao.baidu.com/nchat/api/getorderlist?htj_to=20$514916693507543464866769948616769420439575988&htj_vw=021170451490000000000000000000000000000000000000000000008401ff800376743788EF8938D14B651D9505AB78C58:FG%3D10000000000000&htj_jt=31%2524eyJrIj4iNyI0Iix5IkciQEZISUNHSk9OUU5SVCJJIkFqIjwiNTs9Pjg8P0RDRkNHSSI%252BIjYzIlEiSlBSUlZSUTA1NDg3NSIzIit5IkYiQz9AQSI%252FIjkiUSJMSE5KUVciLCJsIj4iNnEvTTBuLHhbcVEpWV8wNilQTDBja1J1RHJ4Mylvam0%252Bek1AQlRuZDZEeTJjKmtmZ0lpaDhKclZiYHY0Kl03SzZyKl5CTT0wT0g2MFZ5MzczYklcLWFfLjFvbmlEZHF5PzhtNC5gXUMqRytaczEpZV5GMkhxM3JlY0JPaGM2ZTZ1cjk0clg9KWZVRENbV01ZOEpZajUrU2dRP1J1TmZdcGtcbFRRd0RiLmZAail5L28rbWNBLDhCZS1HdUJ2TC95N1UsSjosRHk0WHgqXy56WzFwXklScU5lOm9xbkVYdXVfS1JiOm1DNDNfaGszWHpkOEZyPDYuLztBZHZNcVRSNl5LVHhAKVRxLHMwLmJsSDMvLz9NK3BfYmhETXRzWmVHWnpLS24vc1guRFZBeWhcW05OTz9lQkwycXg1Sls8VUlIUklYK25vc3BHczdFXW1FSkloP0pAQDIza1hUaVt4c195dTBTVk9Eb1M4LURbOmZIbWptNHNTP01uZUtcUFNHS2tbdGNZLWc0QFRbWHVkSm1JL0krQ101clY0SEVmUXl6UE9wXm4sVFJccjd5LWVbbnBdQTlDTUJqV2NjWnNZUHxNWFFBd3JWendeYS07eGJeZ143b0ArNjc0TnBESk95VDsvQTx6cUEqUFVmT3xFRXxKSEwuLC0sV1E3OGZoPDdrP2o8Qzxtb3RBRkNKdnlHKiJ9&htj_app=universe&listtype=payorder&subsidyTokenVersion=v1&pn=0&rn=20&verifyCodeDs=&verifyCodeToken=&verifyInfo=eyJjbGlja0RpZmYiOjJ9&url=%2Fnchat%2Fapi%2Fgetorderlist']",
// 			"acsOkRate": 0.999758,
// 			"absrOkRate": 0.054424,
// 			"ts": "[[\"202302221540\",47],[\"202302221005\",323],[\"202302221642\",19],[\"202302221145\",162],[\"202302221210\",6],[\"202302221335\",99],[\"202302221405\",295],[\"202302221610\",57],[\"202302221115\",324],[\"202302221510\",325],[\"202302221330\",115],[\"202302221545\",53],[\"202302221000\",295],[\"202302221647\",68],[\"202302221140\",124],[\"202302221615\",62],[\"202302221110\",307],[\"202302221515\",344],[\"202302221400\",76],[\"202302221415\",351],[\"202302221105\",309],[\"202302221600\",192],[\"202302221500\",377],[\"202302221015\",330],[\"202302221550\",63],[\"202302221155\",99],[\"202302221651\",43],[\"202302221200\",133],[\"202302221748\",1],[\"202302221325\",115],[\"202302221100\",332],[\"202302221605\",206],[\"202302221505\",327],[\"202302221410\",370],[\"202302221205\",123],[\"202302221320\",99],[\"202302221010\",327],[\"202302221555\",73],[\"202302221150\",110],[\"202302221656\",7],[\"202302221350\",142],[\"202302221730\",6],[\"202302221705\",102],[\"202302221120\",314],[\"202302221525\",329],[\"202302221020\",342],[\"202302221455\",343],[\"202302220950\",391],[\"202302221050\",320],[\"202302221307\",20],[\"202302221420\",303],[\"202302221702\",22],[\"202302221125\",143],[\"202302221520\",353],[\"202302221025\",368],[\"202302221355\",79],[\"202302221425\",320],[\"202302221450\",321],[\"202302220955\",341],[\"202302221055\",329],[\"202302221445\",350],[\"202302221040\",336],[\"202302221625\",4],[\"202302221315\",97],[\"202302221430\",312],[\"202302221340\",87],[\"202302221720\",44],[\"202302221130\",47],[\"202302221715\",63],[\"202302221030\",469],[\"202302221535\",366],[\"202302221310\",40],[\"202302221435\",357],[\"202302220947\",93],[\"202302221440\",315],[\"202302221045\",353],[\"202302221620\",87],[\"202302221135\",37],[\"202302221710\",105],[\"202302221035\",384],[\"202302221530\",437],[\"202302221345\",112],[\"202302221725\",29]]"
// 		},
// 		{
// 			"subid": "('app','h5')",
// 			"idType": "ip",
// 			"idValue": "183.253.0.160",
// 			"riskLevel": "highRisk",
// 			"risk10Pv": 21522,
// 			"pv": 21648,
// 			"urlCnt": 21627,
// 			"urlDemo": "['https://wen.baidu.com/nchat/api/getorderlist?fr=pay_zdr_askbottombar-find_order&listtype=payorder&subsidyTokenVersion=v1&htj_to=40%245149167586314130721768279318167707244902247260e20e07282ece4f3a30de05b54790f231c41a0ad671b8ab27262bd0e1daa84c0250c6eb51675863143248Ukl3Y0pDZWVhWUdPT3FPWjdRQF9GljEVX2Hji9FZaveGf10DjfCQT9HGjq4CyFSmYF4uCZMXCgTuFnfdfyWHkHppjfhvbEH0toIOrICHw8M%3Dc188dece82&htj_vw=02120d451490000000000000000000000000000000000000000000008401ff8000000000000000000000000000000000000000000000000000000000&htj_app=android&htj_ver=13.27.0.12&htj_zid=sdJeH01XGt5qYHfH4UM1qCOVDNa9w3qaWziXOv-GkhM_y66MFwl53YUHfNydtRFVC-dkIanNFUTCSUlSQ74dZyg&htj_jt=40%25245149167586314130721768279318167707244884574290e20e07282ece4f3a30de05b54790f231c41a0ad671b8ab27262bd0e1daa84c0250c6eb51675863143248Ukl3Y0pDZWVhWUdPT3FPWjdRQF9GljEVX2Hji9FZaveGf10DjfCQT9HGjq4CyFSmYF4uCZMXCgTuFnfdfyWHkHppjfhvbEH0toIOrICHw8M%253D841f641d89&mobileInfo=%7B%22Client_Info%22%3A%7B%22brand%22%3A%22Redmi%22%2C%22model%22%3A%22M2004J7AC%22%2C%22version%22%3A%222.7.16%22%2C%22pixelRatio%22%3A2.75%2C%22screenWidth%22%3A392%2C%22screenHeight%22%3A800%2C%22system%22%3A%22Android%2010%22%2C%22platform%22%3A%22android%22%2C%22SDKVersion%22%3A%223.650.3%22%2C%22host%22%3A%22baiduboxapp%22%2C%22imei%22%3A%22%22%2C%22swanNativeVersion%22%3A%222.65.0%22%2C%22devicePixelRatio%22%3A2.75%2C%22locationEnabled%22%3Atrue%2C%22deviceType%22%3A%22phone%22%2C%22orientation%22%3A%22portrait%22%7D%2C%22Client_Type%22%3A%7B%22type%22%3A%22sp-wyw%22%7D%2C%22Gyroscope%22%3A%7B%22x%22%3A-0.00006500000017695129%2C%22y%22%3A0.0006619999767281115%2C%22z%22%3A-0.0022090000566095114%7D%2C%22Accelerometer%22%3A%7B%22x%22%3A0.009489796143405291%2C%22y%22%3A0.009081632811195995%2C%22z%22%3A-0.9985714542622468%7D%2C%22DeviceMotion%22%3A%7B%22alpha%22%3A139.61758422851562%2C%22beta%22%3A0.5210692286491394%2C%22gamma%22%3A-0.5444642305374146%7D%2C%22BatteryInfo%22%3A%7B%22level%22%3A%2299%22%2C%22isCharging%22%3Afalse%7D%2C%22TouchEvent%22%3A%7B%22x%22%3A242%2C%22y%22%3A2169%2C%22area%22%3A0%2C%22pressure%22%3A1%2C%22timestamp%22%3A1677072448777%7D%7D&_rand=16770720947249724751706932075']",
// 			"acsOkRate": 4.6e-05,
// 			"absrOkRate": 4.6e-05,
// 			"ts": "[[\"202302220855\",95],[\"202302222110\",141],[\"202302221705\",113],[\"202302221925\",142],[\"202302221810\",142],[\"202302221020\",95],[\"202302221500\",153],[\"202302222155\",78],[\"202302221210\",75],[\"202302221105\",95],[\"202302221335\",141],[\"202302222240\",56],[\"202302221025\",96],[\"202302221920\",140],[\"202302221815\",142],[\"202302222115\",22],[\"202302221700\",126],[\"202302220850\",96],[\"202302221330\",142],[\"202302222248\",2],[\"202302221100\",94],[\"202302221215\",70],[\"202302221505\",143],[\"202302222150\",38],[\"202302221115\",95],[\"202302221325\",141],[\"202302222252\",52],[\"202302221510\",142],[\"202302222145\",68],[\"202302221200\",93],[\"202302221935\",142],[\"202302221800\",141],[\"202302221030\",86],[\"202302220845\",94],[\"202302222100\",144],[\"202302221715\",30],[\"202302221205\",92],[\"202302221515\",71],[\"202302222140\",96],[\"202302221320\",140],[\"202302222255\",139],[\"202302221110\",94],[\"202302222105\",142],[\"202302221710\",54],[\"202302220840\",94],[\"202302221035\",6],[\"202302221930\",141],[\"202302221805\",142],[\"202302221350\",128],[\"202302222305\",138],[\"202302221044\",6],[\"202302221235\",142],[\"202302221445\",142],[\"202302222130\",120],[\"202302221005\",96],[\"202302221940\",141],[\"202302221835\",141],[\"202302222055\",142],[\"202302221640\",120],[\"202302220910\",96],[\"202302221440\",141],[\"202302222135\",130],[\"202302221230\",99],[\"202302221049\",8],[\"202302221355\",142],[\"202302222300\",136],[\"202302220915\",96],[\"202302222050\",140],[\"202302221645\",122],[\"202302221945\",142],[\"202302221830\",154],[\"202302221000\",95],[\"202302222045\",143],[\"202302221650\",128],[\"202302220900\",83],[\"202302221015\",96],[\"202302221950\",142],[\"202302221825\",151],[\"202302221225\",50],[\"202302221455\",150],[\"202302222121\",32],[\"202302221340\",142],[\"202302222315\",141],[\"202302221050\",95],[\"202302221955\",142],[\"202302221820\",142],[\"202302221010\",96],[\"202302220905\",95],[\"202302222040\",144],[\"202302221655\",124],[\"202302221055\",93],[\"202302221345\",10],[\"202302222310\",136],[\"202302221450\",142],[\"202302222125\",135],[\"202302221220\",75],[\"202302220024\",1],[\"202302221245\",142],[\"202302221555\",125],[\"202302221400\",142],[\"202302222335\",136],[\"202302221150\",95],[\"202302222025\",157],[\"202302221630\",118],[\"202302220955\",96],[\"202302221850\",141],[\"202302221725\",188],[\"202302221155\",104],[\"202302221405\",142],[\"202302222330\",137],[\"202302221550\",96],[\"202302222227\",26],[\"202302221240\",141],[\"202302221855\",141],[\"202302221723\",48],[\"202302220950\",96],[\"202302222020\",145],[\"202302221635\",105],[\"202302220945\",96],[\"202302221840\",141],[\"202302221735\",225],[\"202302222035\",143],[\"202302221620\",120],[\"202302221410\",142],[\"202302222325\",138],[\"202302221140\",101],[\"202302221255\",134],[\"202302221545\",124],[\"202302222230\",69],[\"202302222030\",148],[\"202302221625\",118],[\"202302221845\",141],[\"202302221730\",223],[\"202302220940\",93],[\"202302221540\",138],[\"202302222235\",68],[\"202302221250\",142],[\"202302221145\",96],[\"202302221415\",142],[\"202302222320\",142],[\"202302221915\",141],[\"202302221740\",178],[\"202302220930\",95],[\"202302222000\",141],[\"202302221615\",122],[\"202302221135\",96],[\"202302221425\",149],[\"202302222350\",137],[\"202302221530\",142],[\"202302222205\",108],[\"202302220006\",7],[\"202302221300\",142],[\"202302222005\",141],[\"202302221610\",123],[\"202302220935\",95],[\"202302221910\",142],[\"202302221745\",172],[\"202302220004\",1],[\"202302221305\",148],[\"202302221535\",145],[\"202302222200\",105],[\"202302221420\",147],[\"202302222355\",139],[\"202302221130\",94],[\"202302221520\",144],[\"202302222215\",113],[\"202302220017\",2],[\"202302221310\",142],[\"202302221125\",94],[\"202302221435\",143],[\"202302222340\",138],[\"202302220835\",63],[\"202302222010\",153],[\"202302221605\",56],[\"202302221905\",142],[\"202302221750\",142],[\"202302220920\",96],[\"202302221430\",146],[\"202302222345\",133],[\"202302221120\",95],[\"202302220010\",2],[\"202302221315\",143],[\"202302221525\",144],[\"202302222210\",111],[\"202302220925\",96],[\"202302221900\",142],[\"202302221755\",143],[\"202302222015\",221],[\"202302221600\",146],[\"202302220834\",2]]"
// 		},
// 		{
// 			"subid": "('app','h5')",
// 			"idType": "ip",
// 			"idValue": "222.217.123.16",
// 			"riskLevel": "highRisk",
// 			"risk10Pv": 14353,
// 			"pv": 14516,
// 			"urlCnt": 14516,
// 			"urlDemo": "['https://zhidao.baidu.com/nchat/api/getorderlist?htj_to=20$514916769964635642367236283216769964944449562&htj_vw=021170451490000000000000000000000000000000000000000000008401ff8003782A870B0BA62280D2A38683BC28CDA78:FG%3D10000000000000&htj_jt=31%2524eyJrIj4iNyI0Iix5IkciQEZISExNTEhPSE9NTiJJIkFqIjwiNTs9PUFCQT1EPURCQyI%252BIjYzIlEiSlBSUlZXVTQ6NTo6OyIzIit5IkYiQz9AQSI%252FIjkiUSJMSE5KUVciLCJsIj4iclxrUW13KnB3NGhqVz5benpCXkFoNG4zTztKbzh1Lyl5K2x1ZHoxUjlxNClqdFVhbWBxaW5fQT1qaXI3TVo6T09uTUFDTGBbWGRoL0VoNV5GNE8vTWU4QlA9MlYqdkpRTHRpYSw%252BTWcwKzRfVzJjakFJWjgrMTNuSXJaWFMySFp0T04sUlt3PywveDZWLnY6XF43TkltMF5hb0JlSFg7OVpqLVx5MjBvZlQzZ0t0ajFcWTpaUy46UmhpWGdHSnArPE1SeUJBYXN5WlQySURVRFtgXy1vbTtlU3A4VCpJdk94N3pMS116Um93SWlBaDRWeVg9aVxhOzc9Olh4dl0zNXpVUlJQPSpcNl5gQmQsdjZHbFozLWtpQmtGb25SPDl1eVVQP1RaVXpoKzV1YVp2eSxccDtiKzFfMTRTN3RRVktINlVcQS9uXHBHQnoyV2F4KSlncE1KVDFTV2VjNSp1Nk46QFl3Uy10T1BcWF83Qy9dX0A%252BYGJLMUUwNnN0T2k1UF9vd3VBUG5CZjMpeUNgOkhYSjo8TDYzbjNLOE08cEdMbEp6OTNbQi9mRE58dkMqaC5JTW07L0F2bU9iNXZbeT1eOU0wbVxmUi9UMDgpW2lYK2NQN2BfQlt8MTF8ZWU5PD04PW49REJwP3F3RXhEdkxQKU5LVE5QTzNhZTcifQ%253D%253D&htj_app=universe&listtype=payorder&subsidyTokenVersion=v1&pn=0&rn=20&verifyCodeDs=&verifyCodeToken=&verifyInfo=eyJjbGlja0RpZmYiOjB9&url=%2Fnchat%2Fapi%2Fgetorderlist']",
// 			"acsOkRate": 1,
// 			"absrOkRate": 0.866285,
// 			"ts": "[[\"202302221045\",206],[\"202302220945\",236],[\"202302221435\",35],[\"202302221310\",161],[\"202302220020\",169],[\"202302220110\",53],[\"202302221220\",199],[\"202302221345\",159],[\"202302221035\",251],[\"202302221135\",197],[\"202302221430\",156],[\"202302221315\",160],[\"202302220025\",229],[\"202302221040\",206],[\"202302220940\",226],[\"202302221030\",41],[\"202302221130\",219],[\"202302221225\",201],[\"202302221340\",160],[\"202302221230\",211],[\"202302220100\",194],[\"202302221355\",155],[\"202302221025\",128],[\"202302221125\",329],[\"202302221055\",201],[\"202302220955\",203],[\"202302221425\",151],[\"202302221300\",156],[\"202302220030\",252],[\"202302221020\",40],[\"202302221120\",244],[\"202302221235\",157],[\"202302220105\",173],[\"202302221350\",158],[\"202302221420\",155],[\"202302220035\",335],[\"202302221305\",157],[\"202302221050\",235],[\"202302220950\",237],[\"202302221255\",162],[\"202302221410\",153],[\"202302220915\",210],[\"202302220920\",148],[\"202302221100\",261],[\"202302221150\",210],[\"202302221010\",304],[\"202302221320\",161],[\"202302221205\",197],[\"202302220055\",369],[\"202302220925\",201],[\"202302221105\",278],[\"202302221250\",161],[\"202302221415\",154],[\"202302220913\",59],[\"202302221325\",156],[\"202302221200\",199],[\"202302220050\",120],[\"202302221155\",200],[\"202302221015\",196],[\"202302221140\",203],[\"202302221000\",166],[\"202302221330\",156],[\"202302221215\",199],[\"202302220045\",292],[\"202302221245\",156],[\"202302221400\",151],[\"202302220930\",220],[\"202302221110\",174],[\"202302221335\",159],[\"202302221210\",202],[\"202302220040\",279],[\"202302221145\",242],[\"202302221005\",163],[\"202302220935\",206],[\"202302221115\",200],[\"202302221240\",159],[\"202302221405\",155]]"
// 		},
// 		{
// 			"subid": "('app','h5')",
// 			"idType": "ip",
// 			"idValue": "223.104.178.189",
// 			"riskLevel": "highRisk",
// 			"risk10Pv": 18154,
// 			"pv": 18801,
// 			"urlCnt": 495,
// 			"urlDemo": "['https://zhidao.baidu.com/nchat/api/getorderlist?htj_to=20$514916754030670635124974319616770555539265733&htj_vw=021170451490000000000000000000000000000000000000000000008401ff8003723B4084BDD228F2924DEA9A8BA5B0E78:FG%3D10000000000000&htj_jt=31%2524eyJrIj4iNyI0Iix5IkciQEZISUNJSktMTEpTSyJJIkFqIjwiNTs9Pjg%252BP0BBQT9IQCI%252BIjYzIlEiSlBSU01TVDU2NTc3PCIzIit5IkYiQz9AQSI%252FIjkiUSJMSE5KUVciLCJsIj4iLFBTNGNscTg%252FNHFfWlQrdmt6MGUwZ05mQmJDZi1YSj01bzBPdnVwLl12MmpFMEh2LWlgMjYsM0NwTjZQUmw8aHlJelxRMCp4cVdjdDY6OylNK3J6MDpVXzg%252BU3hKRFxHcjZLQHc6YE5neCxlekhENC0wZ11RZEdTMT1wby1QNEluazM5KSlhP1FkMjhpQjFhei81SzxsTE1gZzV1cVdZenRuOi86QEFaVVgtSkpZXj1dYDhSKV92ZlZOQzladWZSPDtBXGN2cSxaSDtWN21KQGJmMVEyb1AuRjRMOlkpaU5WK0F4VS5Xdi1YaS0zSUg7YXplWz9gYm54ZGcpSW1yeXFVLVt2WlIsVFBxXDV6NkB6OTUvQl4zbGtrYilHcl5MLjI%252BeTAwWl5AMHVmdWMqSV55LD1iXy5AcjRzTUtcSkxtcz86PzZaVmQzXVNXXXU4Z14taT1UazJfbmp4OE45XjhbW3NUPj52Uz9YZFMpbnguMmItXk5PYl9jZSxNeFsqLmtbTixNKlVlYS1aZ0ZMejMvP0s3dFJzYjc1TVVmSVo9aCpXVT5aLHFTRHJYbWQ5TSosblJyTGpGais5UVMpXV9ocEJXXk9dRSk2Yyk7dlxfXTpbNlxZWnx2a2lPMis8R0g6UGN1d18rc3hVMmVIQDNvOjxJMW0%252BbzNaMVppLzxqW1wqR3w9PXxwRkhJR0t2SSlQSlFNVVMvMzQ4OTU5PmxobGxuQXFAciJ9&htj_app=universe&listtype=payorder&subsidyTokenVersion=v1&pn=0&rn=20&verifyCodeDs=&verifyCodeToken=&verifyInfo=eyJjbGlja0RpZmYiOjB9&url=%2Fnchat%2Fapi%2Fgetorderlist']",
// 			"acsOkRate": 0.001649,
// 			"absrOkRate": 0.044253,
// 			"ts": "[[\"202302221705\",412],[\"202302221730\",436],[\"202302221250\",228],[\"202302221420\",219],[\"202302221305\",223],[\"202302221415\",218],[\"202302221650\",447],[\"202302221020\",112],[\"202302221745\",420],[\"202302221345\",224],[\"202302221215\",232],[\"202302221620\",210],[\"202302221815\",431],[\"202302221615\",206],[\"202302221820\",428],[\"202302221330\",224],[\"202302221220\",232],[\"202302221545\",207],[\"202302221350\",221],[\"202302221635\",216],[\"202302221800\",427],[\"202302221600\",201],[\"202302221835\",36],[\"202302221235\",229],[\"202302221325\",222],[\"202302221550\",206],[\"202302221710\",435],[\"202302221725\",438],[\"202302221245\",237],[\"202302221400\",221],[\"202302221310\",220],[\"202302221645\",390],[\"202302221750\",418],[\"202302221555\",204],[\"202302221230\",228],[\"202302221320\",220],[\"202302221830\",433],[\"202302221605\",215],[\"202302220915\",24],[\"202302221805\",434],[\"202302221630\",221],[\"202302221355\",224],[\"202302221755\",435],[\"202302221640\",212],[\"202302221405\",217],[\"202302221315\",215],[\"202302221240\",227],[\"202302221720\",441],[\"202302221715\",437],[\"202302221740\",423],[\"202302221655\",434],[\"202302221025\",83],[\"202302221300\",222],[\"202302221410\",219],[\"202302221255\",226],[\"202302221425\",161],[\"202302221735\",428],[\"202302221700\",429],[\"202302221540\",209],[\"202302221335\",224],[\"202302221225\",229],[\"202302221825\",426],[\"202302220855\",129],[\"202302221610\",202],[\"202302221810\",428],[\"202302220900\",115],[\"202302221625\",215],[\"202302221536\",154],[\"202302221340\",223],[\"202302221214\",9]]"
// 		}
// 	];

//     const data1 = [
//         {
//             "subid": "('app','h5')",
//             "idType": "uid",
//             "idValue": "1546672389",
//             "riskLevel": "highRisk",
//             "risk10Pv": 13634,
//             "pv": 13760,
//             "urlCnt": 29,
//             "urlDemo": "['https://zhidao.baidu.com/nchat/api/getorderlist?htj_to=20$514916754010028338954859492716770555363633746&htj_vw=021170451490000000000000000000000000000000000000000000008401ff80037591D9758CD317CE168FF244E9258BCDD:FG%3D10000000000000&htj_jt=31%2524eyJrIj4iNyI0Iix5IkciQEZISUNJSktKUExQUiJJIkFqIjwiNTs9Pjg%252BP0A%252FRUFFRyI%252BIjYzIlEiSlBSU01TUDM5Mzg4NSIzIit5IkYiQz9AQSI%252FIjkiUSJMSE5KUVciLCJsIj4iZ3VNXi9VTilWelY2ZGpeZiszLStjczhAVWdkcVA0LC1bSXVNdjFtLnhRdiw5YVhtMzhLYzUuZjJPVWs1RjRaLXUtXWsuWSt0NjVDLy4qRmQ5Yi4qN28uQHdPV2hueE03YD54YT5EYFFmWGBcVUksby0rOE9tUGYwRTl4eHYpNG1YdXhhXjIpcXRVeWJdalVANHlrQWtqSzVzSjBkTi48OklyVV9iNnRuXmFGdXk%252BNGxXazYpc2JRQHVTVld3SllHZ08pOE1cPDwrZkZbM2MuN2RsYTlkZ3VRQ0JaTVZYbXRUPz06VDxlPm9SeEAyYkxjbU4wYWxtK0VfbGxPVGdqK1hrSlR5eGBgX3VoNjpbelwqeDErO1JBdWRQQ0pMaEwpV212WnE8ZWA%252BMC93KXZsa0ZOcWM%252FTGsyZjZ0MHBJODsqLF9XUTNwYy5ceCwpaTBdYD5DS2xoOG9yb2VDbHNQbnF1Tlc5VnNAZ1g4KTZdXEttM2dnKmFddkVXQkdvWGpKT1FLdDpPZSlQR1tjMC9gLUw6QC1jM2JBPGkwdXNIZmlSOG9MUHpjXF1zV3VeNlcyL0ZZenQ8bG40bUtYRztvNXxvXG9MUEBFQEc1LSs3d2VYLmtlb04yUGl5dDNEXHpdTnQ8PTlfZmNVM2JST3xFRXwqTkwsK09WL1A1ZTY7N2g6N2prPkI%252FPUc%252FRURKeEpMSCJ9&htj_app=universe&listtype=payorder&subsidyTokenVersion=v1&pn=0&rn=20&verifyCodeDs=&verifyCodeToken=&verifyInfo=eyJjbGlja0RpZmYiOjc5fQ%3D%3D&url=%2Fnchat%2Fapi%2Fgetorderlist']",
//             "acsOkRate": 0.002108,
//             "absrOkRate": 0.060465,
//             "ts": "[[\"202302221240\",227],[\"202302221715\",223],[\"202302221720\",229],[\"202302221640\",212],[\"202302221755\",225],[\"202302221405\",217],[\"202302221315\",215],[\"202302221630\",221],[\"202302221805\",224],[\"202302221355\",224],[\"202302221230\",228],[\"202302221320\",220],[\"202302221555\",204],[\"202302221605\",215],[\"202302221830\",225],[\"202302221625\",215],[\"202302221810\",221],[\"202302221340\",223],[\"202302221214\",9],[\"202302221536\",154],[\"202302221335\",224],[\"202302221225\",229],[\"202302221540\",209],[\"202302221610\",202],[\"202302221825\",220],[\"202302221255\",226],[\"202302221425\",161],[\"202302221700\",220],[\"202302221735\",222],[\"202302221655\",222],[\"202302221740\",213],[\"202302221300\",222],[\"202302221410\",219],[\"202302221820\",221],[\"202302221615\",206],[\"202302221545\",207],[\"202302221330\",224],[\"202302221220\",232],[\"202302221345\",224],[\"202302221215\",232],[\"202302221815\",220],[\"202302221620\",210],[\"202302221305\",223],[\"202302221415\",218],[\"202302221745\",217],[\"202302221650\",232],[\"202302221730\",225],[\"202302221705\",207],[\"202302221250\",228],[\"202302221420\",219],[\"202302221400\",221],[\"202302221310\",220],[\"202302221750\",214],[\"202302221645\",220],[\"202302221725\",226],[\"202302221710\",225],[\"202302221245\",237],[\"202302221835\",19],[\"202302221600\",201],[\"202302221550\",206],[\"202302221235\",229],[\"202302221325\",222],[\"202302221350\",220],[\"202302221800\",219],[\"202302221635\",216]]"
//         },
//         {
//             "subid": "('app','h5')",
//             "idType": "uid",
//             "idValue": "1703586996",
//             "riskLevel": "highRisk",
//             "risk10Pv": 10388,
//             "pv": 10477,
//             "urlCnt": 10415,
//             "urlDemo": "['https://wen.baidu.com/nchat/api/getorderlist?fr=pay_zdr_workbench_order&listtype=payorder&subsidyTokenVersion=v1&htj_to=40%245149167664043297857468914917167706201941641839997f56bc60f6a8361eba41bf12b36fb8f0d1e90774fa76d89c29090b40b7cd4411ee4941676640431775YXFmUHFkSUx4ekpnTnJJd4Sfux_8ZiCEUd89u8xPHNDX2cUezXGo4aBw94VthYfQ3JxmJeri1W7d9_jfWrvqFNyDS9VRjh-AbrxQAR5Cm4o%3De594ac7b45&htj_vw=02120d451490000000000000000000000000000000000000000000008401ff8000000000000000000000000000000000000000000000000000000000&htj_app=android&htj_ver=13.27.0.12&htj_zid=uCz04r6rJ23gzlNXJWK1TFXx8vwW1ny-538TSi1PVoQrhybrJBjG5NWyC6to7UoQNMLMBsib_SNQHEDO8R2Tlpg&htj_jt=40%25245149167664043297857468914917167706201925777939997f56bc60f6a8361eba41bf12b36fb8f0d1e90774fa76d89c29090b40b7cd4411ee4941676640431775YXFmUHFkSUx4ekpnTnJJd4Sfux_8ZiCEUd89u8xPHNDX2cUezXGo4aBw94VthYfQ3JxmJeri1W7d9_jfWrvqFNyDS9VRjh-AbrxQAR5Cm4o%253Deabb706cac&mobileInfo=%7B%22Client_Info%22%3A%7B%22brand%22%3A%22OPPO%22%2C%22model%22%3A%22PCLM50%22%2C%22version%22%3A%222.7.16%22%2C%22pixelRatio%22%3A3%2C%22screenWidth%22%3A360%2C%22screenHeight%22%3A756%2C%22system%22%3A%22Android%2012%22%2C%22platform%22%3A%22android%22%2C%22SDKVersion%22%3A%223.650.3%22%2C%22host%22%3A%22baiduboxapp%22%2C%22imei%22%3A%22%22%2C%22swanNativeVersion%22%3A%222.65.0%22%2C%22devicePixelRatio%22%3A3%2C%22locationEnabled%22%3Afalse%2C%22deviceType%22%3A%22phone%22%2C%22orientation%22%3A%22portrait%22%7D%2C%22Client_Type%22%3A%7B%22type%22%3A%22sp-wyw%22%7D%2C%22Gyroscope%22%3A%7B%22x%22%3A-0.06298190355300903%2C%22y%22%3A0.018907885998487473%2C%22z%22%3A-0.0014646954368799925%7D%2C%22Accelerometer%22%3A%7B%22x%22%3A-0.046605102869929096%2C%22y%22%3A-0.5052091150867696%2C%22z%22%3A-0.9042367156671017%7D%2C%22DeviceMotion%22%3A%7B%22alpha%22%3A110.54969787597656%2C%22beta%22%3A-29.285186767578125%2C%22gamma%22%3A3.1418020725250244%7D%2C%22TouchEvent%22%3A%7B%22x%22%3A288%2C%22y%22%3A2166%2C%22area%22%3A0.019607844%2C%22pressure%22%3A1%2C%22timestamp%22%3A1677062019060%7D%2C%22BatteryInfo%22%3A%7B%22level%22%3A%2263%22%2C%22isCharging%22%3Afalse%7D%7D&_rand=1677059369122635365359838892']",
//             "acsOkRate": 0,
//             "absrOkRate": 0,
//             "ts": "[[\"202302221226\",109],[\"202302221825\",167],[\"202302221910\",115],[\"202302220940\",61],[\"202302221610\",132],[\"202302220715\",195],[\"202302221145\",8],[\"202302221535\",10],[\"202302220810\",265],[\"202302220725\",205],[\"202302221955\",108],[\"202302221743\",34],[\"202302221655\",52],[\"202302221505\",4],[\"202302221300\",49],[\"202302221450\",110],[\"202302221255\",146],[\"202302220750\",268],[\"202302220825\",176],[\"202302221735\",118],[\"202302221920\",137],[\"202302221700\",198],[\"202302221943\",49],[\"202302221755\",58],[\"202302220805\",203],[\"202302220730\",223],[\"202302221640\",78],[\"202302221445\",79],[\"202302221240\",152],[\"202302221721\",107],[\"202302220745\",243],[\"202302220830\",68],[\"202302221715\",140],[\"202302221556\",101],[\"202302221230\",205],[\"202302220843\",81],[\"202302221830\",161],[\"202302221905\",90],[\"202302221605\",179],[\"202302221632\",57],[\"202302221520\",43],[\"202302221710\",137],[\"202302221728\",23],[\"202302220740\",247],[\"202302221245\",258],[\"202302221110\",42],[\"202302221440\",149],[\"202302221515\",81],[\"202302221647\",54],[\"202302221750\",156],[\"202302221945\",140],[\"202302220735\",186],[\"202302220800\",241],[\"202302221635\",104],[\"202302220925\",230],[\"202302221858\",37],[\"202302221600\",198],[\"202302221900\",61],[\"202302221835\",160],[\"202302221236\",54],[\"202302221140\",104],[\"202302221531\",61],[\"202302220930\",19],[\"202302221818\",22],[\"202302221840\",110],[\"202302220712\",99],[\"202302221915\",108],[\"202302221820\",118],[\"202302220647\",31],[\"202302221137\",76],[\"202302221705\",196],[\"202302220820\",228],[\"202302220755\",232],[\"202302221925\",73],[\"202302221730\",64],[\"202302221250\",148],[\"202302221455\",51],[\"202302221305\",22],[\"202302222240\",20],[\"202302221500\",230],[\"202302222239\",36],[\"202302221650\",105],[\"202302220720\",253],[\"202302220815\",263],[\"202302221745\",127],[\"202302221950\",139]]"
//         },
//         {
//             "subid": "('app','h5')",
//             "idType": "uid",
//             "idValue": "2759588978",
//             "riskLevel": "highRisk",
//             "risk10Pv": 11151,
//             "pv": 11270,
//             "urlCnt": 11270,
//             "urlDemo": "['https://zhidao.baidu.com/nchat/api/getorderlist?htj_to=20$514916769964635642367236283216770291284508932&htj_vw=021170451490000000000000000000000000000000000000000000008401ff8003782A870B0BA62280D2A38683BC28CDA78:FG%3D10000000000000&htj_jt=31%2524eyJrIj4iNyI0Iix5IkciQEZISUNHTUdKUE1MTiJJIkFqIjwiNTs9Pjg8Qjw%252FRUJBQyI%252BIjYzIlEiSlBSUlZXVTQ6NTo6OyIzIit5IkYiQz9AQSI%252FIjkiUSJMSE5KUVciLCJsIj4iak9feStxYXRTQGYtMlhpOFhla15lNmF0VHVBNDZFcF9tU3hqekw7VzNWVi0zdkVKPFlDXzdtc0R4aURjO3M4d3ZqdEptdS0%252FLHc0dTBDd0VmSD5jUHRjNS01Y3JkWStYdE9uYUNgclhPcmNYVUY%252FYnd4cStjRmM2ZD5NUkgpSVRTPjBtTkNBMlUuQnJlMDRhXWcuak5lbU5fOmVWUmxHdTFWcik6TTtgVHJ5LjVieGpJQm0qRSstZ2Y%252FUW1QdlB5X203X1hwRU9HdF5TSWA5bGE0UC9yVC06UXFLamlpUTQ8cWtsUypOUFR0MipGO0cvYExLc3RpNWY%252BcXEsZlI7OHRzVj1XciszW3NJPEEvNDhBOk1Jc3N1b240ZkxlNl5eTG9uT2AtUHNCQkdUWWNrek1uWlBOUEwxeGhCUHRmMyopU0wpTFBkRWBYVDd0aVw3O3ArYmdcYG13U0FnW2tGaGxxdypTMHNUYDFoaHhEODlwK0syXkY6OUJgY05cPE44SFx4b20tKjxbX180WWgxKWNQTSxdMFlafGdWY000SEhodTBsc1JTNVVEd0lkRi9oTGxLZTYtPW9FQWVVeUZNVXFOMy5HfD09fEJ2RkZ3REdPR3lKTVFSMVMzODIzPDlmZz85QTptPkA%252FIn0%253D&htj_app=universe&listtype=payorder&subsidyTokenVersion=v1&pn=0&rn=20&verifyCodeDs=&verifyCodeToken=&verifyInfo=eyJjbGlja0RpZmYiOjB9&url=%2Fnchat%2Fapi%2Fgetorderlist']",
//             "acsOkRate": 1,
//             "absrOkRate": 0.848802,
//             "ts": "[[\"202302221255\",162],[\"202302221425\",151],[\"202302221100\",162],[\"202302220105\",171],[\"202302221010\",167],[\"202302220050\",60],[\"202302221300\",156],[\"202302221410\",153],[\"202302221055\",164],[\"202302220935\",170],[\"202302220021\",114],[\"202302221340\",160],[\"202302221210\",165],[\"202302221145\",159],[\"202302221335\",159],[\"202302221225\",163],[\"202302221130\",165],[\"202302220940\",166],[\"202302220920\",93],[\"202302220035\",175],[\"202302220915\",167],[\"202302221205\",159],[\"202302221355\",155],[\"202302221150\",163],[\"202302221230\",162],[\"202302221320\",161],[\"202302221125\",161],[\"202302220955\",171],[\"202302221430\",156],[\"202302221240\",159],[\"202302221115\",160],[\"202302220110\",32],[\"202302221005\",163],[\"202302220045\",164],[\"202302221405\",155],[\"202302221315\",160],[\"202302221040\",164],[\"202302220950\",167],[\"202302221120\",166],[\"202302221235\",157],[\"202302221325\",156],[\"202302221155\",162],[\"202302221200\",161],[\"202302221350\",158],[\"202302220913\",37],[\"202302220030\",176],[\"202302220925\",160],[\"202302221045\",169],[\"202302221400\",151],[\"202302221310\",161],[\"202302220040\",173],[\"202302221036\",115],[\"202302221000\",166],[\"202302221110\",165],[\"202302221435\",35],[\"202302221245\",156],[\"202302221050\",166],[\"202302221305\",157],[\"202302221415\",154],[\"202302220055\",171],[\"202302221015\",87],[\"202302220100\",152],[\"202302221105\",162],[\"202302221250\",161],[\"202302221420\",155],[\"202302220945\",168],[\"202302221135\",161],[\"202302221330\",156],[\"202302221220\",160],[\"202302221140\",164],[\"202302221345\",159],[\"202302221215\",162],[\"202302220025\",172],[\"202302220930\",165]]"
//         },
//         {
//             "subid": "('app','h5')",
//             "idType": "uid",
//             "idValue": "6386844083",
//             "riskLevel": "highRisk",
//             "risk10Pv": 18850,
//             "pv": 18956,
//             "urlCnt": 18954,
//             "urlDemo": "['https://wen.baidu.com/nchat/api/getorderlist?fr=pay_zdr_askbottombar-find_order&listtype=payorder&subsidyTokenVersion=v1&htj_to=40%245149167586314130721768279318167706603090297640e20e07282ece4f3a30de05b54790f231c41a0ad671b8ab27262bd0e1daa84c0250c6eb51675863143248R2FwWmFPSklyc2x5amhldtPL_mgEqgxjN_bSV6959_ZPJLj_8qUSh92zHV21XDeoFOV0LtaKHL-3vFHLGXSS7MMf490LULnGgnZFaY9jU-k%3D5190c08460&htj_vw=02120d451490000000000000000000000000000000000000000000008401ff8000000000000000000000000000000000000000000000000000000000&htj_app=android&htj_ver=13.27.0.12&htj_zid=sdJeH01XGt5qYHfH4UM1qCOVDNa9w3qaWziXOv-GkhM-smm3LB4EmhvTdW_agBEydyGkBaalehU7zD1ObephvYw&htj_jt=40%25245149167586314130721768279318167706603069728610e20e07282ece4f3a30de05b54790f231c41a0ad671b8ab27262bd0e1daa84c0250c6eb51675863143248R2FwWmFPSklyc2x5amhldtPL_mgEqgxjN_bSV6959_ZPJLj_8qUSh92zHV21XDeoFOV0LtaKHL-3vFHLGXSS7MMf490LULnGgnZFaY9jU-k%253Ddcbe524348&mobileInfo=%7B%22Client_Info%22%3A%7B%22brand%22%3A%22Redmi%22%2C%22model%22%3A%22M2004J7AC%22%2C%22version%22%3A%222.7.16%22%2C%22pixelRatio%22%3A2.75%2C%22screenWidth%22%3A392%2C%22screenHeight%22%3A800%2C%22system%22%3A%22Android%2010%22%2C%22platform%22%3A%22android%22%2C%22SDKVersion%22%3A%223.650.3%22%2C%22host%22%3A%22baiduboxapp%22%2C%22imei%22%3A%22%22%2C%22swanNativeVersion%22%3A%222.65.0%22%2C%22devicePixelRatio%22%3A2.75%2C%22locationEnabled%22%3Atrue%2C%22deviceType%22%3A%22phone%22%2C%22orientation%22%3A%22portrait%22%7D%2C%22Client_Type%22%3A%7B%22type%22%3A%22sp-wyw%22%7D%2C%22Accelerometer%22%3A%7B%22x%22%3A0.013673469728353071%2C%22y%22%3A0.05061224407079268%2C%22z%22%3A-0.996836740143445%7D%2C%22Gyroscope%22%3A%7B%22x%22%3A0.001934999949298799%2C%22y%22%3A0.002013999968767166%2C%22z%22%3A0.00120900000911206%7D%2C%22DeviceMotion%22%3A%7B%22alpha%22%3A159.22149658203125%2C%22beta%22%3A2.906574249267578%2C%22gamma%22%3A-0.7848580479621887%7D%2C%22BatteryInfo%22%3A%7B%22level%22%3A%22100%22%2C%22isCharging%22%3Atrue%7D%2C%22TouchEvent%22%3A%7B%22x%22%3A246%2C%22y%22%3A2202%2C%22area%22%3A0%2C%22pressure%22%3A1%2C%22timestamp%22%3A1677066030597%7D%7D&_rand=16770577932459156662400196864']",
//             "acsOkRate": 0.000369,
//             "absrOkRate": 0.000317,
//             "ts": "[[\"202302220920\",96],[\"202302221630\",111],[\"202302222105\",142],[\"202302221805\",142],[\"202302221850\",141],[\"202302220915\",96],[\"202302221355\",142],[\"202302222343\",1],[\"202302221205\",11],[\"202302221150\",95],[\"202302221520\",142],[\"202302222135\",97],[\"202302221320\",140],[\"202302221230\",99],[\"202302221125\",94],[\"202302222140\",78],[\"202302221555\",125],[\"202302220955\",96],[\"202302220004\",1],[\"202302222050\",140],[\"202302221605\",56],[\"202302221905\",142],[\"202302221830\",142],[\"202302220840\",94],[\"202302221240\",141],[\"202302221430\",142],[\"202302222210\",111],[\"202302221445\",142],[\"202302221115\",95],[\"202302222020\",141],[\"202302221715\",10],[\"202302221005\",96],[\"202302220834\",2],[\"202302221935\",142],[\"202302221723\",49],[\"202302221640\",119],[\"202302222015\",142],[\"202302221030\",86],[\"202302221755\",142],[\"202302221940\",141],[\"202302221315\",142],[\"202302221405\",142],[\"202302221510\",142],[\"202302222227\",23],[\"202302221044\",6],[\"202302221425\",142],[\"202302221255\",134],[\"202302221100\",94],[\"202302222205\",104],[\"202302221450\",142],[\"202302221010\",96],[\"202302222035\",142],[\"202302221700\",126],[\"202302221920\",140],[\"202302221735\",142],[\"202302220050\",1],[\"202302221025\",96],[\"202302221655\",124],[\"202302222000\",141],[\"202302221740\",142],[\"202302221955\",142],[\"202302221410\",142],[\"202302221300\",142],[\"202302221055\",93],[\"202302221505\",142],[\"202302222230\",56],[\"202302221625\",118],[\"202302222110\",141],[\"202302220024\",1],[\"202302220935\",95],[\"202302220900\",84],[\"202302221810\",142],[\"202302221845\",141],[\"202302221210\",69],[\"202302221340\",142],[\"202302221535\",142],[\"202302222121\",5],[\"202302221145\",95],[\"202302221225\",50],[\"202302221335\",141],[\"202302222155\",75],[\"202302221540\",137],[\"202302221130\",94],[\"202302222045\",142],[\"202302221610\",122],[\"202302220940\",93],[\"202302220017\",2],[\"202302220855\",95],[\"202302221910\",142],[\"202302221825\",142],[\"202302221050\",95],[\"202302222235\",54],[\"202302221500\",142],[\"202302222240\",51],[\"202302221415\",142],[\"202302221305\",141],[\"202302221950\",142],[\"202302221745\",142],[\"202302221020\",95],[\"202302222005\",141],[\"202302221650\",128],[\"202302221730\",142],[\"202302221925\",142],[\"202302221015\",96],[\"202302221705\",104],[\"202302222030\",141],[\"202302221105\",95],[\"202302221455\",142],[\"202302222200\",103],[\"202302221420\",141],[\"202302221250\",142],[\"202302220850\",96],[\"202302221820\",142],[\"202302221915\",141],[\"202302221615\",122],[\"202302222040\",142],[\"202302220010\",2],[\"202302220945\",96],[\"202302221545\",124],[\"202302222150\",36],[\"202302221135\",96],[\"202302221220\",72],[\"202302221330\",142],[\"202302222126\",71],[\"202302221530\",142],[\"202302221140\",96],[\"202302221215\",68],[\"202302221345\",10],[\"202302220905\",95],[\"202302221840\",141],[\"202302221815\",142],[\"202302222115\",21],[\"202302221620\",120],[\"202302220930\",95],[\"202302220026\",1],[\"202302221835\",141],[\"202302221900\",142],[\"202302220845\",94],[\"202302220006\",7],[\"202302220950\",96],[\"202302221600\",140],[\"202302222055\",141],[\"202302221120\",95],[\"202302221550\",95],[\"202302222145\",68],[\"202302221325\",141],[\"202302221235\",142],[\"202302221155\",96],[\"202302222130\",101],[\"202302221525\",142],[\"202302221350\",128],[\"202302221200\",84],[\"202302221855\",141],[\"202302221800\",141],[\"202302220910\",96],[\"202302220925\",96],[\"202302220033\",1],[\"202302222100\",141],[\"202302221635\",105],[\"202302221515\",67],[\"202302221049\",8],[\"202302221310\",140],[\"202302221400\",142],[\"202302221945\",142],[\"202302221750\",142],[\"202302222010\",141],[\"202302221645\",122],[\"202302221035\",6],[\"202302220044\",1],[\"202302220835\",63],[\"202302221725\",142],[\"202302221930\",141],[\"202302221710\",52],[\"202302222025\",142],[\"202302221000\",95],[\"202302221440\",141],[\"202302222215\",111],[\"202302221110\",94],[\"202302221245\",142],[\"202302221435\",142]]"
//         },
//         {
//             "subid": "('app','h5')",
//             "idType": "uid",
//             "idValue": "6395136179",
//             "riskLevel": "highRisk",
//             "risk10Pv": 12546,
//             "pv": 12676,
//             "urlCnt": 12603,
//             "urlDemo": "['https://wen.baidu.com/nchat/submit/cananswer']",
//             "acsOkRate": 0,
//             "absrOkRate": 0,
//             "ts": "[[\"202302221015\",245],[\"202302221250\",126],[\"202302221420\",23],[\"202302221105\",238],[\"202302221415\",243],[\"202302221050\",199],[\"202302221650\",245],[\"202302221020\",226],[\"202302221532\",111],[\"202302221620\",216],[\"202302221840\",164],[\"202302221815\",211],[\"202302220905\",233],[\"202302221615\",239],[\"202302221820\",180],[\"202302220850\",246],[\"202302221545\",102],[\"202302221635\",247],[\"202302220925\",146],[\"202302220911\",159],[\"202302221800\",32],[\"202302221602\",127],[\"202302220848\",75],[\"202302221836\",193],[\"202302221235\",174],[\"202302221000\",245],[\"202302221435\",212],[\"202302221245\",248],[\"202302221400\",244],[\"202302221045\",238],[\"202302221035\",248],[\"202302221645\",199],[\"202302221230\",246],[\"202302221830\",3],[\"202302221605\",204],[\"202302220959\",1],[\"202302220915\",194],[\"202302221807\",29],[\"202302221850\",25],[\"202302221630\",248],[\"202302220920\",245],[\"202302221356\",148],[\"202302221755\",139],[\"202302221030\",223],[\"202302221640\",247],[\"202302221040\",198],[\"202302221405\",214],[\"202302221431\",186],[\"202302221240\",243],[\"202302221005\",225],[\"202302221655\",205],[\"202302221025\",249],[\"202302221055\",214],[\"202302221410\",237],[\"202302221100\",230],[\"202302221700\",209],[\"202302221010\",222],[\"202302221540\",203],[\"202302221227\",98],[\"202302221910\",46],[\"202302221825\",206],[\"202302220855\",240],[\"202302221610\",234],[\"202302221811\",132],[\"202302221845\",224],[\"202302220900\",209],[\"202302221625\",227],[\"202302221535\",239]]"
//         }
//     ];
//     return new Promise(r => {
//         setTimeout(() => {
//             r({
//                 res: 0,
//                 data: p.idType === 'ip' ? data : data1
//             });
//         }, 1000);
//     });
// };


export const getBusinessAnalyseScenes = p => get('/api/v1/analysisReport/config', p);
// export const getBusinessAnalyseScenes = p => {
//     return new Promise((r) => {
//         setTimeout(() => {
//             r({
//                 res: 0,
//                 data: [{
//                     sid: 7102,
//                     subid: 'abc',
//                     scene: '问一问双周报',
//                     sceneId: 1
//                 }]
//             })
//         }, 500);
//     })
// }

export const getBusinessAnalyserReportList = p => get('/api/v1/analysisReport/list', p);

// export const getBusinessAnalyserReportList = p => {
//     return new Promise((r) => {
//         setTimeout(() => {
//             r({
//                 res: 0,
//                 data: [
//                     {
//                         "sceneId": 1,
//                         "dt": 20230325,
//                         "status": "failed"
//                     },
//                     {
//                         "sceneId": 1,
//                         "dt": 20230326,
//                         "status": "success"
//                     },
//                     {
//                         "sceneId": 1,
//                         "dt": 20230327,
//                         "status": "queued"
//                     }
//                 ]
//             })
//         }, 500);
//     })
// }

export const createBusinessAnalyserReport = p => post('/api/v1/analysisReport/create', p);
// export const createBusinessAnalyserReport = p => {
//     return new Promise((r) => {
//         setTimeout(() => {
//             r({
//                 "res": 0,
//                 "msg": "ok",
//                 "data": "success"
//             })
//         }, 1000);
//     });
// }

export const getApiCaptchaData = p => get('/api/v1/api_stat/captcha', p);
export const getApiCaptchaTrigger = p => get('/api/v1/api_stat/captcha_trigger', p);
export const getApiCaptchaStatus = p => get('/api/v1/api_stat/captcha_verify_status', p);